var _path, _polygon, _path2, _polygon2, _path3, _polygon3, _path4, _polygon4, _circle, _polygon5, _path5, _polygon6, _path6, _polygon7, _path7, _polygon8, _path8, _polygon9, _path9, _polygon10, _polygon11, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnline2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.5,464.46c0,.15-95.15.26-212.49.26s-212.51-.11-212.51-.26,95.13-.26,212.51-.26S462.5,464.32,462.5,464.46Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.11,
    y: 417.08,
    width: 56.43,
    height: 7.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.63,424.93H88V417h56.62Zm-56.42-.19h56.23v-7.56H88.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.34 422.25 101.46 462.32 131.51 462.32 139.37 424.83 93.34 422.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.34 458.53 97.67 464.49 134.2 464.49 139.37 458.53 93.34 458.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,423.43c-.11,0-.25-18.57-.31-41.46s0-41.46.08-41.46.25,18.56.32,41.46S114.32,423.42,114.2,423.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77,377a1.45,1.45,0,0,1-.15.43l-.5,1.2c-.11.27-.24.56-.37.87s-.24.68-.38,1-.28.79-.43,1.21-.27.9-.42,1.38a58.53,58.53,0,0,0-1.58,6.91,85.78,85.78,0,0,0-.87,8.64,115.89,115.89,0,0,0,.45,15.78c.18,2,.36,3.64.49,4.77l.15,1.29a2,2,0,0,1,0,.46,2.07,2.07,0,0,1-.1-.45c-.06-.33-.13-.76-.22-1.28-.18-1.12-.41-2.75-.63-4.76a104.16,104.16,0,0,1-.56-15.83,78.24,78.24,0,0,1,.91-8.68,52,52,0,0,1,1.67-6.93c.16-.49.29-.95.45-1.38s.32-.83.46-1.21.29-.72.41-1,.28-.6.41-.86l.57-1.17A2.14,2.14,0,0,1,126.77,377Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,362a4.81,4.81,0,0,1-.18.61c-.14.43-.34,1-.59,1.73-.13.37-.27.79-.43,1.24l-.45,1.5c-.33,1.07-.71,2.29-1.05,3.67-.18.68-.37,1.4-.57,2.14s-.35,1.54-.53,2.35c-.39,1.62-.68,3.37-1,5.2-.62,3.69-1.17,7.77-1.55,12.07s-.51,8.41-.57,12.15,0,7.11.19,9.94c0,1.41.15,2.69.22,3.81s.13,2.09.2,2.88.11,1.36.14,1.81a2.82,2.82,0,0,1,0,.64,6.21,6.21,0,0,1-.1-.63c-.05-.45-.12-1.05-.21-1.81s-.19-1.75-.28-2.87-.2-2.4-.27-3.82c-.19-2.83-.27-6.2-.28-9.95s.18-7.87.54-12.19.94-8.4,1.58-12.09c.38-1.84.68-3.6,1.09-5.21.19-.81.37-1.6.55-2.35s.4-1.46.59-2.15c.36-1.37.76-2.59,1.11-3.66.18-.53.34-1,.49-1.49s.33-.86.47-1.24c.27-.71.49-1.28.66-1.7A3.35,3.35,0,0,1,125.33,362Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.64,426.71a.74.74,0,0,1,0-.22c0-.16,0-.38,0-.64,0-.59-.1-1.41-.17-2.45-.13-2.17-.32-5.25-.56-9-.49-7.63-1.2-18.18-2.48-29.77-.66-5.8-1.42-11.31-2.21-16.3-.42-2.49-.81-4.86-1.24-7.07s-.82-4.26-1.22-6.13-.78-3.56-1.11-5-.65-2.75-.91-3.79-.45-1.81-.59-2.39c0-.26-.1-.46-.14-.63s0-.21,0-.21,0,.07.07.2.11.37.18.62l.66,2.37c.29,1,.63,2.3,1,3.78s.78,3.15,1.17,5,.86,3.91,1.27,6.13.84,4.58,1.27,7.07c.81,5,1.59,10.51,2.25,16.31,1.28,11.61,1.94,22.17,2.36,29.81.21,3.82.35,6.91.44,9.05l.09,2.46v.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.74,349.43c-.24-2.63-2.9-4.61-5.54-4.64a8.74,8.74,0,0,0-6.72,3.65,21.12,21.12,0,0,0-3.23,7.18,48.72,48.72,0,0,0-2,19.1A28.88,28.88,0,0,0,104.21,392,3.25,3.25,0,0,0,107,393.2a3.3,3.3,0,0,0,1.44-.89,42.8,42.8,0,0,0,13.88-32.52,13.17,13.17,0,0,0-1.74-7c-1.35-2-4.49-4.18-6.79-3.37",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,328.37,90.3,335.1c-.08.16-.2.34-.38.35s-.34-.17-.45-.33q-4.91-7.55-9.83-15.09l2.27-1.29Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94,328.37,90.3,335.1c-.08.16-.2.34-.38.35s-.34-.17-.45-.33q-4.91-7.55-9.83-15.09l2.27-1.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M114,340.51l-33.55-19.8a1.54,1.54,0,0,1-.81-.82c-.14-.5.24-1,.59-1.35a23.12,23.12,0,0,1,17.93-7,20.49,20.49,0,0,1,16.21,10.08c3.24,5.78,3.34,13.44-.37,18.93",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.26,314.39a2.19,2.19,0,0,1,.44-.05,12.31,12.31,0,0,1,1.27-.06,24.45,24.45,0,0,1,4.65.37,27.18,27.18,0,0,1,21.71,19.64,25.8,25.8,0,0,1,.84,4.6c.06.55,0,.69,0,1a1.77,1.77,0,0,1-.26.73,6.07,6.07,0,0,0,.05-1.69A28,28,0,0,0,87,314.43,16.26,16.26,0,0,1,85.26,314.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,326.84a8.15,8.15,0,0,1-1.7.77c-1.06.43-2.56,1-4.23,1.5s-3.2.95-4.32,1.22a8.41,8.41,0,0,1-1.83.35,8.79,8.79,0,0,1,1.76-.62l4.27-1.34,4.26-1.37A10,10,0,0,1,109.43,326.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15,312.65a14.33,14.33,0,0,1,.39,3.75,13.92,13.92,0,0,1-.2,3.75,22.91,22.91,0,0,1-.2-3.74A22.37,22.37,0,0,1,104.15,312.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.13,320.34a13.67,13.67,0,0,1,2.44-.86c1.52-.47,3.64-1.07,6-1.64s4.53-1,6.1-1.28a15.18,15.18,0,0,1,2.56-.35,17.43,17.43,0,0,1-2.51.63c-1.55.35-3.69.83-6.06,1.39s-4.48,1.12-6,1.52A19.38,19.38,0,0,1,80.13,320.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.82,343.73c-2.89-2.19-5.94-2.62-9.55-2.48A29.21,29.21,0,0,0,79.81,344c-5.66,2.48-11,6.13-14.36,11.3s-4.55,12-2,17.64a2.52,2.52,0,0,0,1.14,1.39,2.73,2.73,0,0,0,1.9-.14c6.43-2.1,12.91-4.22,18.83-7.51s11.3-7.85,14.47-13.83a12,12,0,0,0,1.53-4.59,5.72,5.72,0,0,0-1.48-4.48",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.88,343.05l-.47.18-1.34.47-1,.32-1.14.45c-.81.33-1.76.66-2.75,1.14l-1.58.72c-.55.25-1.1.56-1.67.86-1.17.57-2.35,1.3-3.61,2a63.16,63.16,0,0,0-7.61,5.65,62.23,62.23,0,0,0-6.58,6.84c-.9,1.15-1.77,2.23-2.49,3.31-.36.54-.74,1-1.06,1.55l-.92,1.47c-.6.93-1.05,1.82-1.48,2.59-.21.39-.41.74-.58,1.07s-.32.65-.45.93l-.63,1.28a2.1,2.1,0,0,1-.25.43,3.36,3.36,0,0,1,.17-.46l.57-1.32.41-.94.56-1.09c.42-.78.85-1.69,1.44-2.63l.9-1.5c.31-.51.68-1,1-1.57.71-1.1,1.58-2.19,2.47-3.35a59.42,59.42,0,0,1,6.6-6.91,60.06,60.06,0,0,1,7.69-5.66c1.27-.74,2.46-1.47,3.64-2,.59-.29,1.14-.6,1.69-.84l1.6-.7c1-.47,2-.78,2.79-1.09.42-.15.8-.3,1.16-.42l1-.29,1.37-.39A1.64,1.64,0,0,1,99.88,343.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.34,355.25a67.25,67.25,0,0,1-7,2.26,65.59,65.59,0,0,1-7.13,1.88,66.54,66.54,0,0,1,7-2.26A67.56,67.56,0,0,1,77.34,355.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.05,370.74a10.75,10.75,0,0,1-.16-2.19c0-1.35,0-3.22,0-5.28s.17-3.93.28-5.28a11.55,11.55,0,0,1,.27-2.17,11.87,11.87,0,0,1,0,2.19c0,1.48-.1,3.28-.16,5.27s-.1,3.79-.13,5.27A14.07,14.07,0,0,1,77.05,370.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.31,364c-.11,0-.46-3.79-.78-8.48S89,347,89.14,347s.46,3.79.79,8.48S90.43,364,90.31,364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8,346.62a12.9,12.9,0,0,1,2.25-.07c1.39,0,3.3.05,5.42.12s4,.16,5.41.24a11.63,11.63,0,0,1,2.24.22,14.28,14.28,0,0,1-2.25.07c-1.39,0-3.3-.05-5.42-.12s-4-.16-5.41-.24A12.56,12.56,0,0,1,73.8,346.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.65,392.83a1.57,1.57,0,0,1-.05-.45c0-.34,0-.76-.06-1.29-.05-1.12-.06-2.74,0-4.75s.17-4.39.41-7,.64-5.54,1.18-8.55,1.23-5.86,1.91-8.43,1.42-4.85,2.1-6.75,1.25-3.41,1.69-4.45l.51-1.19a1.87,1.87,0,0,1,.2-.4,1.63,1.63,0,0,1-.12.43c-.12.32-.26.72-.44,1.22-.4,1.05-.94,2.58-1.57,4.48s-1.32,4.19-2,6.75-1.32,5.4-1.87,8.41-.93,5.89-1.21,8.52-.42,5-.5,7-.11,3.62-.1,4.74c0,.52,0,1,0,1.29A2.71,2.71,0,0,1,105.65,392.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,370.86a9.29,9.29,0,0,1-1.34,1.47c-.87.87-2.1,2-3.51,3.26s-2.72,2.31-3.69,3.05a9.59,9.59,0,0,1-1.63,1.14,10.17,10.17,0,0,1,1.45-1.36l3.61-3.13,3.57-3.16A11,11,0,0,1,107.42,370.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,379.42a16.23,16.23,0,0,1-1.42-2l-3.32-4.83c-1.28-1.82-2.44-3.47-3.38-4.79a16.8,16.8,0,0,1-1.36-2,12.75,12.75,0,0,1,1.59,1.86c.93,1.18,2.17,2.84,3.48,4.73s2.44,3.63,3.23,4.91A13,13,0,0,1,118,379.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.47,352.52c.06.09-3.47,2.47-7.88,5.3s-8,5.06-8.09,5,3.47-2.47,7.88-5.31S112.41,352.42,112.47,352.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42,363.25a65.38,65.38,0,0,1-5.34-4.93,63.71,63.71,0,0,1-5-5.22,67.72,67.72,0,0,1,5.33,4.94A66,66,0,0,1,122.42,363.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.92,363l3-.25a15.11,15.11,0,0,0,6.11-1.87,23.78,23.78,0,0,1,2.85-1.44c3.75-1.5,7.92-1.23,12-1.43a49.62,49.62,0,0,0,19-4.86,1.85,1.85,0,0,0,.83-.76c.62-1.13-.53-2.14-1.53-2.75-5.1-3.14-10.29-6.33-16.08-7.89s-12.35-1.29-17.29,2.1c-5.79,4-7.9,12.18-8.88,19.15",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77,352.06a2.19,2.19,0,0,1-.52-.24l-1.43-.75c-1.25-.65-3-1.62-5.3-2.7a49.37,49.37,0,0,0-8.21-3.17,27.24,27.24,0,0,0-10.63-.86,18.23,18.23,0,0,0-9.7,4.16,21.76,21.76,0,0,0-5,7.1,58.24,58.24,0,0,0-2.19,5.52c-.23.63-.41,1.14-.54,1.52a4.77,4.77,0,0,1-.21.53,2.25,2.25,0,0,1,.13-.55c.12-.39.27-.91.47-1.55a49.54,49.54,0,0,1,2.09-5.59,21.3,21.3,0,0,1,5.06-7.25,18.42,18.42,0,0,1,9.88-4.29,27,27,0,0,1,10.79.91,47.47,47.47,0,0,1,8.23,3.26c2.26,1.12,4,2.13,5.25,2.82l1.4.82A3.74,3.74,0,0,1,168.77,352.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5,356c-.07.09-4-2.47-8.85-5.72s-8.68-6-8.62-6.06,4,2.47,8.85,5.73S161.56,355.88,161.5,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.27,344a9.44,9.44,0,0,1-2.88.52,9.56,9.56,0,0,1-2.94,0,19.74,19.74,0,0,1,2.9-.29A20.38,20.38,0,0,1,157.27,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.93,341.73a7.44,7.44,0,0,1-1.29,2,8.45,8.45,0,0,1-1.65,1.87,7.65,7.65,0,0,1,1.3-2A8.56,8.56,0,0,1,139.93,341.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,358.3a10.49,10.49,0,0,1-1.9-1c-1.15-.69-2.69-1.71-4.34-2.91s-3.11-2.34-4.16-3.17a10.32,10.32,0,0,1-1.64-1.41,12,12,0,0,1,1.81,1.19l4.22,3.06c1.65,1.2,3.16,2.25,4.26,3A12.68,12.68,0,0,1,143.48,358.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.38,375.9c-2.89-.76-6.33,2.05-6.93,5s.5,5.92,1.79,8.61a43.91,43.91,0,0,0,11.94,15.63,29.5,29.5,0,0,0,18.26,6.72c-1.22-5.67.33-11.59-.35-17.35a22.58,22.58,0,0,0-20-19.8c-1.84-.2-4-.49-4.71,1.21",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.44,411.84a1.58,1.58,0,0,1-.41-.19,7.91,7.91,0,0,1-1.08-.72,11.45,11.45,0,0,1-2.85-3.82c-.46-.89-1-1.86-1.48-2.94s-1-2.22-1.55-3.43a33.94,33.94,0,0,0-1.91-3.67,28.77,28.77,0,0,0-2.63-3.58c-2-2.32-4.1-4.33-5.94-6.25a40.85,40.85,0,0,1-4.52-5.43,19.67,19.67,0,0,1-2.22-4.23,12.32,12.32,0,0,1-.38-1.23,1.64,1.64,0,0,1-.09-.45s.2.59.62,1.63a21.71,21.71,0,0,0,2.3,4.12,42.51,42.51,0,0,0,4.56,5.33c1.85,1.9,4,3.91,6,6.25a29.51,29.51,0,0,1,2.66,3.63,33.8,33.8,0,0,1,1.91,3.73c.53,1.21,1,2.36,1.52,3.44s1,2.05,1.42,3a11.69,11.69,0,0,0,2.7,3.83C153.9,411.53,154.47,411.8,154.44,411.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.51,407.13a9.09,9.09,0,0,1,.26-1.94c.23-1.19.6-2.83,1.1-4.6s1-3.37,1.47-4.5a8.59,8.59,0,0,1,.79-1.8,11.81,11.81,0,0,1-.52,1.89c-.36,1.15-.85,2.74-1.35,4.51s-.91,3.39-1.21,4.56A9.64,9.64,0,0,1,139.51,407.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.9,393.21a11.11,11.11,0,0,1-2-.47c-1.24-.32-3-.77-4.87-1.2s-3.66-.76-4.92-1a12.69,12.69,0,0,1-2-.45,9.12,9.12,0,0,1,2.08.17c1.28.16,3,.46,5,.89s3.63.92,4.86,1.32A10.47,10.47,0,0,1,153.9,393.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.79,397.25a12.31,12.31,0,0,1,.31-2.25c.26-1.37.66-3.27,1.2-5.34s1.12-3.92,1.57-5.25a11.78,11.78,0,0,1,.83-2.12,14.93,14.93,0,0,1-.56,2.2c-.38,1.35-.91,3.21-1.45,5.27s-1,3.94-1.31,5.3A12.51,12.51,0,0,1,128.79,397.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.27,381.08c0,.11-3.62-.18-8.05-.65s-8-.94-8-1.05a77.83,77.83,0,0,1,8,.65C143.7,380.5,147.28,381,147.27,381.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.63,424.8c0,.11-12.67.2-28.31.2s-28.3-.09-28.3-.2,12.67-.2,28.3-.2S144.63,424.69,144.63,424.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.81,441.11c0,.11-8.54.2-19.07.2s-19.07-.09-19.07-.2,8.54-.2,19.07-.2S135.81,441,135.81,441.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.48,443.44c0,.12-8.39.21-18.74.21S98,443.56,98,443.44s8.39-.2,18.74-.2S135.48,443.33,135.48,443.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.14,439.19c0,.11-8.83.2-19.72.2s-19.73-.09-19.73-.2,8.83-.2,19.73-.2S136.14,439.08,136.14,439.19Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.17,120.31h-6.46a5,5,0,0,0-2,.21,3.06,3.06,0,0,0-1.53,1.36,3.4,3.4,0,0,0-.37,1,7.12,7.12,0,0,0,0,1.14v1.18a5.7,5.7,0,0,1-.08,1.23,3.27,3.27,0,0,1-1.44,2.08A3.1,3.1,0,0,1,136,129c-.46,0-.9,0-1.37,0H111.23a3.27,3.27,0,0,1-.93-.09,3.09,3.09,0,0,1-1.61-1,3.34,3.34,0,0,1-.79-1.75,7.92,7.92,0,0,1,0-1v-1a5,5,0,0,0-.2-1.9,3.08,3.08,0,0,0-1.15-1.51,3,3,0,0,0-1.86-.51H89.76a9.92,9.92,0,0,0-8,3.52,9.88,9.88,0,0,0-2,4.11,11.72,11.72,0,0,0-.2,1.16c0,.33,0,.66,0,1v158.8a10.31,10.31,0,0,0,.4,3.13,9.84,9.84,0,0,0,3.84,5.28,10.23,10.23,0,0,0,6.32,1.73h58.74c2.09,0,4.19,0,6.24,0a9.84,9.84,0,0,0,5.6-2.17,10.21,10.21,0,0,0,2-2.23,9.71,9.71,0,0,0,1.24-2.72,10.52,10.52,0,0,0,.37-3V274.15c0-31.25,0-59.38.05-83s0-42.75.06-56v-4.68a10.17,10.17,0,0,0-.72-4,9.94,9.94,0,0,0-1.87-2.95,9.63,9.63,0,0,0-2.25-1.83,9.44,9.44,0,0,0-3.71-1.31,8.13,8.13,0,0,0-1-.09l-.34,0h-5.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6,120.42h.34a10,10,0,0,1,1,.08,9.92,9.92,0,0,1,6,3.12,9.84,9.84,0,0,1,1.89,3,10.19,10.19,0,0,1,.74,4c0,1.47,0,3,0,4.68,0,13.22,0,32.34,0,56s0,51.77,0,83v14.86a10.72,10.72,0,0,1-.38,3A10.1,10.1,0,0,1,163,295a10.71,10.71,0,0,1-2.07,2.29,10,10,0,0,1-5.73,2.22c-2.08.06-4.14,0-6.23,0H136.31l-25.93,0h-20A10.5,10.5,0,0,1,84,297.71,10.22,10.22,0,0,1,80,292.28a11,11,0,0,1-.41-3.36V272.31q0-13.17,0-25.94c0-17,0-33.4,0-49s0-30.47,0-44.37q0-10.41,0-20.1v-2.41c0-.4,0-.8.06-1.2s.1-.8.2-1.19a10.08,10.08,0,0,1,2.09-4.2,10.05,10.05,0,0,1,8.09-3.58H105a3.24,3.24,0,0,1,2,.55,3.28,3.28,0,0,1,1.21,1.59,5.49,5.49,0,0,1,.2,2v1a7.26,7.26,0,0,0,0,.94,3.18,3.18,0,0,0,.74,1.67,3,3,0,0,0,1.52.94,3.28,3.28,0,0,0,.89.08H116l13.08,0h5.77c.45,0,.91,0,1.35,0a3,3,0,0,0,1.21-.42,3.17,3.17,0,0,0,1.39-2,5.47,5.47,0,0,0,.08-1.21v-1.18a7.45,7.45,0,0,1,.05-1.16,3.44,3.44,0,0,1,.38-1.06,3.07,3.07,0,0,1,1.58-1.4,4.8,4.8,0,0,1,2-.21h6.44l3.95,0h1.35l-1.35,0H142.86a4.78,4.78,0,0,0-1.94.21,3.1,3.1,0,0,0-1.53,1.36,3.38,3.38,0,0,0-.36,1,7,7,0,0,0-.05,1.14v1.18a5.68,5.68,0,0,1-.07,1.23,3.23,3.23,0,0,1-1.44,2.07,2.94,2.94,0,0,1-1.26.45c-.46,0-.9,0-1.36,0H111.5a3.67,3.67,0,0,1-.93-.09,3.11,3.11,0,0,1-1.61-1,3.37,3.37,0,0,1-.78-1.74,7.92,7.92,0,0,1,0-1v-1a5.05,5.05,0,0,0-.2-1.9,3.1,3.1,0,0,0-1.15-1.5,2.92,2.92,0,0,0-1.85-.51H90.11A9.88,9.88,0,0,0,82.18,124a9.86,9.86,0,0,0-2,4.12c-.1.38-.13.77-.2,1.16s0,.78,0,1.18V288.92a10.66,10.66,0,0,0,.4,3.28,9.9,9.9,0,0,0,3.82,5.28,10.22,10.22,0,0,0,6.31,1.73h20l25.93,0h12.63c2.08,0,4.17,0,6.22,0a9.74,9.74,0,0,0,5.57-2.16,10.44,10.44,0,0,0,2-2.23,9.81,9.81,0,0,0,1.23-2.72,10.19,10.19,0,0,0,.37-3v-3c0-4,0-8,0-11.86,0-31.25,0-59.39,0-83s0-42.75.05-56c0-1.65,0-3.21,0-4.68a10.08,10.08,0,0,0-.73-4,9.8,9.8,0,0,0-1.86-2.94,9.94,9.94,0,0,0-5.94-3.14,6.35,6.35,0,0,0-1-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.52,136.49s-1.64.09-3.66.11-3.66,0-3.66,0,1.63-.09,3.66-.11S156.52,136.45,156.52,136.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54,138.37s-1.64.09-3.67.1-3.66,0-3.66,0,1.64-.09,3.66-.11S156.54,138.32,156.54,138.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.55,140.24s-1.64.09-3.66.11-3.66,0-3.66,0,1.64-.09,3.66-.11S156.55,140.2,156.55,140.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,142.38h.15l.43,0,1.56,0,0,0c0-.35,0-.72,0-1.13,0-.21,0-.41,0-.66a.61.61,0,0,1,.53-.48h.74a.6.6,0,0,1,.52.6c0,.53,0,1.08,0,1.66l-.08-.07,2,0-.08.07c0-.79,0-1.61,0-2.46,0-.21,0-.42,0-.62a.63.63,0,0,0-.27-.47l-.87-.85-.83-.82-.4-.4c-.14-.13-.25-.27-.41-.3a.54.54,0,0,0-.45.08c-.12.1-.25.25-.37.36l-.71.72c-.44.46-.91.88-1.24,1.28a1.33,1.33,0,0,0-.1.74v.69c0,.43,0,.8,0,1.12s0,.53,0,.72a1.11,1.11,0,0,1,0,.26,2.17,2.17,0,0,1,0-.24c0-.19,0-.42,0-.7l0-1.13c0-.23,0-.46,0-.71v-.39a.87.87,0,0,1,.11-.41c.37-.45.8-.85,1.25-1.32l.7-.72c.13-.12.23-.25.38-.38a.7.7,0,0,1,.58-.11,1.1,1.1,0,0,1,.47.34l.41.39.83.82.86.85a1.28,1.28,0,0,1,.22.24.65.65,0,0,1,.11.33v.63c0,.84,0,1.67,0,2.46v.08H93.64v-.07c0-.57,0-1.13,0-1.66a.48.48,0,0,0-.4-.48c-.22,0-.49,0-.71,0a.5.5,0,0,0-.43.39c0,.19,0,.43,0,.63,0,.41,0,.78,0,1.13v0H89.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.64,208c0,.28-7.85.51-17.53.51s-17.52-.23-17.52-.51,7.84-.51,17.52-.51S139.64,207.74,139.64,208Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.16,
    y: 156.62,
    width: 34.02,
    height: 45.27,
    transform: "translate(-57.76 300.42) rotate(-89.68)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.44 196.14 115.37 175.08 125.09 188.37 131.77 181.33 144.71 196.39 99.44 196.14",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33,172.57a3.56,3.56,0,1,1-3.54-3.59A3.56,3.56,0,0,1,129.33,172.57Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "99.44 196.14 115.37 175.08 125.09 188.37 131.77 181.33 144.71 196.39 99.44 196.14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.33,172.57a3.56,3.56,0,1,1-3.54-3.59A3.56,3.56,0,0,1,129.33,172.57Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M153.28,220.54c0,.29-13.92.52-31.07.52s-31.08-.23-31.08-.52S105,220,122.21,220,153.28,220.26,153.28,220.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.28,229.2c0,.29-13.92.52-31.07.52s-31.08-.23-31.08-.52,13.91-.51,31.08-.51S153.28,228.92,153.28,229.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.28,237.87c0,.28-13.92.51-31.07.51s-31.08-.23-31.08-.51,13.91-.52,31.08-.52S153.28,237.58,153.28,237.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.28,246.53c0,.28-13.92.51-31.07.51s-31.08-.23-31.08-.51S105,246,122.21,246,153.28,246.25,153.28,246.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.28,255.19c0,.29-13.92.52-31.07.52s-31.08-.23-31.08-.52,13.91-.51,31.08-.51S153.28,254.91,153.28,255.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.91,263.1c0,.14-2,.27-5.22.36s-7.69.15-12.62.15-9.38-.05-12.61-.15-5.22-.22-5.22-.36,2-.27,5.22-.36,7.69-.15,12.61-.15,9.39.05,12.62.15S139.91,263,139.91,263.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.29,105.77h-7.18A5.31,5.31,0,0,0,202,106a3.37,3.37,0,0,0-1.71,1.52,3.49,3.49,0,0,0-.4,1.15,7.62,7.62,0,0,0-.06,1.27c0,.44,0,.88,0,1.33a7.12,7.12,0,0,1-.09,1.37,3.65,3.65,0,0,1-1.6,2.31,3.45,3.45,0,0,1-1.41.5c-.51,0-1,0-1.52,0h-26a4.12,4.12,0,0,1-1-.1,3.49,3.49,0,0,1-1.79-1.11,3.69,3.69,0,0,1-.87-2,7.8,7.8,0,0,1,0-1.08v-1.07a5.77,5.77,0,0,0-.21-2.12,3.41,3.41,0,0,0-1.29-1.68,3.24,3.24,0,0,0-2.06-.57H145.27a10.94,10.94,0,0,0-8.84,3.92,11.15,11.15,0,0,0-2.28,4.59c-.11.42-.14.86-.22,1.29s0,.74-.05,1.11V293.83a11.63,11.63,0,0,0,.44,3.48,11,11,0,0,0,4.27,5.89,11.37,11.37,0,0,0,7,1.94h22.26l28.92,0h14.09c2.32,0,4.65,0,6.93,0a10.9,10.9,0,0,0,6.22-2.41,11.83,11.83,0,0,0,2.25-2.49,11,11,0,0,0,1.37-3,11.86,11.86,0,0,0,.42-3.3V277.34c0-34.85,0-66.23.06-92.59s0-47.68.06-62.42c0-1.85,0-3.59,0-5.22a11.36,11.36,0,0,0-.81-4.46,11,11,0,0,0-2.08-3.28,10.64,10.64,0,0,0-2.5-2.05,10.37,10.37,0,0,0-4.12-1.45,8.9,8.9,0,0,0-1.12-.11l-.38,0h-1.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.28,105.66l.38,0a7.77,7.77,0,0,1,1.12.08,11.15,11.15,0,0,1,6.68,3.48,11.06,11.06,0,0,1,2.1,3.3,11.39,11.39,0,0,1,.83,4.5c0,1.63,0,3.37,0,5.21,0,14.75,0,36.07,0,62.43s0,57.74,0,92.58v16.59a11.67,11.67,0,0,1-.42,3.37,11.28,11.28,0,0,1-1.42,3.12,11.92,11.92,0,0,1-2.3,2.56,11.25,11.25,0,0,1-6.39,2.48c-2.32.07-4.62,0-7,0H145.69a11.77,11.77,0,0,1-7.2-2,11.38,11.38,0,0,1-4.39-6.06,12.19,12.19,0,0,1-.46-3.74V275.06q0-14.69,0-28.93c0-19,0-37.25,0-54.68s0-34,0-49.48q0-11.62,0-22.43v-2.68c0-.45,0-.9.06-1.34s.11-.89.23-1.32a11.21,11.21,0,0,1,2.33-4.69,11.5,11.5,0,0,1,4.1-3.07,11.68,11.68,0,0,1,4.92-.93h16.56a3.48,3.48,0,0,1,2.17.61,3.68,3.68,0,0,1,1.36,1.78,6,6,0,0,1,.22,2.18v1.08a7.26,7.26,0,0,0,0,1,3.46,3.46,0,0,0,.82,1.86,3.35,3.35,0,0,0,1.69,1,3.73,3.73,0,0,0,1,.09h5l14.59,0h6.44c.5,0,1,0,1.5,0a3.25,3.25,0,0,0,1.36-.47,3.55,3.55,0,0,0,1.55-2.23,6.09,6.09,0,0,0,.08-1.35c0-.44,0-.88,0-1.32a8,8,0,0,1,.05-1.29,4,4,0,0,1,.42-1.18,3.55,3.55,0,0,1,1.77-1.57,5.56,5.56,0,0,1,2.2-.23l7.17,0,4.42,0h1.5l-1.5,0H204.19a5.48,5.48,0,0,0-2.16.24,3.32,3.32,0,0,0-1.71,1.52,3.51,3.51,0,0,0-.41,1.15,8.88,8.88,0,0,0,0,1.27v1.32a6.34,6.34,0,0,1-.08,1.37,3.62,3.62,0,0,1-1.61,2.32,3.41,3.41,0,0,1-1.4.5c-.52,0-1,0-1.52,0h-26a4.09,4.09,0,0,1-1-.11,3.43,3.43,0,0,1-1.79-1.1,3.69,3.69,0,0,1-.87-1.95,7.92,7.92,0,0,1,0-1.08V110.1a5.79,5.79,0,0,0-.22-2.12A3.48,3.48,0,0,0,164,106.3a3.37,3.37,0,0,0-2.06-.57H145.35a11,11,0,0,0-8.85,3.93,11.19,11.19,0,0,0-2.27,4.59c-.11.42-.14.86-.22,1.29s0,.87-.06,1.32V142c0,15.49,0,32.05,0,49.48v54.68q0,14.24,0,28.93v18.53a11.8,11.8,0,0,0,.45,3.65,11,11,0,0,0,4.27,5.89,11.33,11.33,0,0,0,7,1.93H168l28.92,0H211c2.33,0,4.66,0,6.94,0a10.93,10.93,0,0,0,6.22-2.41,11.52,11.52,0,0,0,2.24-2.49,10.7,10.7,0,0,0,1.38-3,11.42,11.42,0,0,0,.41-3.29c0-1.13,0-2.24,0-3.36V277.26c0-34.84,0-66.22.05-92.58s0-47.68.07-62.43V117a11.54,11.54,0,0,0-.8-4.46,11.09,11.09,0,0,0-2.08-3.29,10.84,10.84,0,0,0-2.5-2,11,11,0,0,0-5.24-1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.42,123.58s-1.83.11-4.08.12-4.09,0-4.09,0,1.83-.1,4.08-.12S219.42,123.54,219.42,123.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.44,125.67s-1.83.11-4.09.12-4.08,0-4.08-.05,1.82-.1,4.08-.12S219.44,125.63,219.44,125.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.45,127.76s-1.82.11-4.08.12-4.09,0-4.09,0,1.83-.1,4.09-.12S219.45,127.72,219.45,127.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.12,130.15h.17l.47,0,1.75,0,0,0c0-.39,0-.81,0-1.26,0-.24,0-.46,0-.73a.68.68,0,0,1,.59-.54,7.65,7.65,0,0,1,.83,0,.67.67,0,0,1,.57.67c0,.59,0,1.21,0,1.84l-.08-.08,2.2,0-.08.09c0-.89,0-1.81,0-2.74v-.7a.69.69,0,0,0-.31-.52l-1-1-.93-.92-.45-.44a1.1,1.1,0,0,0-.46-.34.56.56,0,0,0-.5.1c-.13.11-.28.27-.41.4l-.79.8c-.5.51-1,1-1.39,1.43a1.52,1.52,0,0,0-.11.82v.77c0,.48,0,.9,0,1.25s0,.59,0,.8,0,.29,0,.29,0-.09,0-.26,0-.48,0-.79,0-.78,0-1.26c0-.25,0-.51,0-.79s0-.29,0-.43a.93.93,0,0,1,.12-.46c.41-.5.9-.94,1.4-1.47l.78-.81c.14-.14.26-.27.43-.42a.74.74,0,0,1,.63-.12,1.15,1.15,0,0,1,.53.37l.45.45c.31.29.62.6.93.91l1,1a1.51,1.51,0,0,1,.24.26.63.63,0,0,1,.12.37c0,.23,0,.47,0,.7,0,.94,0,1.86,0,2.75v.08h-.09l-2.2,0h-.08v-.08c0-.64,0-1.26,0-1.85a.52.52,0,0,0-.44-.53c-.26,0-.55,0-.8,0a.55.55,0,0,0-.48.43c0,.22,0,.48,0,.7v1.32h-2.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.6,141.59a7.38,7.38,0,1,1-7.37-7.37A7.37,7.37,0,0,1,189.6,141.59Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76,144.57H179.7V144a2.53,2.53,0,0,1,2.53-2.53h0a2.53,2.53,0,0,1,2.53,2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,140.11a1.49,1.49,0,1,1-1.48-1.49A1.48,1.48,0,0,1,183.71,140.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.59,161.09c0,.31-8.75.57-19.54.57s-19.55-.26-19.55-.57,8.75-.58,19.55-.58S200.59,160.77,200.59,161.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.3,
    y: 176.41,
    width: 25.36,
    height: 33.75,
    transform: "translate(-36.18 350.18) rotate(-89.68)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.03 205.87 152.91 190.17 160.15 200.07 165.13 194.83 174.78 206.06 141.03 205.87",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.32,188.3a2.66,2.66,0,1,1-2.64-2.67A2.66,2.66,0,0,1,163.32,188.3Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "141.03 205.87 152.91 190.17 160.15 200.07 165.13 194.83 174.78 206.06 141.03 205.87"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.32,188.3a2.66,2.66,0,1,1-2.64-2.67A2.66,2.66,0,0,1,163.32,188.3Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 150.58,
    y: 204.22,
    width: 58.63,
    height: 78.01,
    transform: "translate(-64.33 421.77) rotate(-89.68)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.73 272.33 168.18 236.03 184.93 258.93 196.44 246.81 218.74 272.76 140.73 272.33",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.24,231.7a6.14,6.14,0,1,1-6.1-6.17A6.13,6.13,0,0,1,192.24,231.7Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.73 272.33 168.18 236.03 184.93 258.93 196.44 246.81 218.74 272.76 140.73 272.33"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.24,231.7a6.14,6.14,0,1,1-6.1-6.17A6.13,6.13,0,0,1,192.24,231.7Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 189.85,
    y: 176.41,
    width: 25.36,
    height: 33.75,
    transform: "translate(8.12 394.73) rotate(-89.68)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.58 205.87 197.46 190.17 204.7 200.07 209.69 194.83 219.33 206.06 185.58 205.87",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.21,
    cy: 188.28,
    r: 2.66,
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "185.58 205.87 197.46 190.17 204.7 200.07 209.69 194.83 219.33 206.06 185.58 205.87"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 205.21,
    cy: 188.28,
    r: 2.66
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M420.84,115.65h-6.43a5.15,5.15,0,0,0-1.94.21,3.16,3.16,0,0,0-1.89,2.4,6.14,6.14,0,0,0-.05,1.14v1.19a5.08,5.08,0,0,1-.08,1.22A3.29,3.29,0,0,1,409,123.9a3.11,3.11,0,0,1-1.26.44c-.46,0-.91,0-1.37,0H383.05a3.37,3.37,0,0,1-.94-.09,3.11,3.11,0,0,1-1.6-1,3.29,3.29,0,0,1-.78-1.75,8,8,0,0,1,0-1v-1a5,5,0,0,0-.19-1.9,3.08,3.08,0,0,0-1.15-1.51,3,3,0,0,0-1.85-.51H361.65a9.84,9.84,0,0,0-7.93,3.52,10,10,0,0,0-2,4.12,11,11,0,0,0-.19,1.15c0,.33,0,.66-.05,1V284.28a10.25,10.25,0,0,0,.4,3.12,9.85,9.85,0,0,0,3.82,5.28,10.2,10.2,0,0,0,6.3,1.74h20l25.93,0h12.64c2.08,0,4.17,0,6.22,0a9.77,9.77,0,0,0,5.57-2.16,10.18,10.18,0,0,0,2-2.24,9.71,9.71,0,0,0,1.24-2.72,10.12,10.12,0,0,0,.37-2.95v-3q0-6,0-11.86c0-31.24,0-59.38,0-83s0-42.76.06-56c0-1.65,0-3.21,0-4.67a10.37,10.37,0,0,0-.73-4,9.91,9.91,0,0,0-4.1-4.78,9.52,9.52,0,0,0-3.7-1.31c-.44-.08-.78-.06-1-.09l-.34,0h-5.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.34,
    y: 182.94,
    width: 55.84,
    height: 11.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.34,115.56h.34a7.72,7.72,0,0,1,1,.08,10,10,0,0,1,6,3.12,10.24,10.24,0,0,1,1.89,3,10.37,10.37,0,0,1,.74,4v4.68c0,13.21,0,32.34,0,56s0,51.77,0,83v14.87a10.37,10.37,0,0,1-.38,3,9.64,9.64,0,0,1-1.27,2.79,10.48,10.48,0,0,1-2.06,2.3,10.08,10.08,0,0,1-5.73,2.22c-2.08.06-4.15,0-6.24,0H362.15a10.54,10.54,0,0,1-6.46-1.78,10.16,10.16,0,0,1-3.93-5.44,10.89,10.89,0,0,1-.42-3.35v-3.35q0-6.68,0-13.26V241.51c0-17,0-33.41,0-49s0-30.47,0-44.37q0-10.43,0-20.1c0-.81,0-1.61,0-2.41,0-.4,0-.8,0-1.2s.1-.8.2-1.19a10,10,0,0,1,10.18-7.78h14.85a3.21,3.21,0,0,1,1.95.55,3.28,3.28,0,0,1,1.21,1.59,5.07,5.07,0,0,1,.2,2v1a7.26,7.26,0,0,0,0,.94,3.05,3.05,0,0,0,.75,1.66,2.84,2.84,0,0,0,1.51.94,3,3,0,0,0,.9.09h4.49l13.08,0h5.77c.45,0,.92,0,1.35,0a2.84,2.84,0,0,0,1.21-.43,3.09,3.09,0,0,0,1.39-2,4.82,4.82,0,0,0,.08-1.2v-1.19a7.39,7.39,0,0,1,.06-1.15,3.32,3.32,0,0,1,.37-1.07,3.18,3.18,0,0,1,1.59-1.4,5.15,5.15,0,0,1,2-.21l6.43,0,4,0h1.35l-1.35,0H414.6a4.76,4.76,0,0,0-1.94.21,3,3,0,0,0-1.53,1.36,3.16,3.16,0,0,0-.36,1,6.14,6.14,0,0,0,0,1.14v1.19a5.7,5.7,0,0,1-.08,1.23,3.25,3.25,0,0,1-1.43,2.07,3,3,0,0,1-1.27.45c-.46,0-.9,0-1.36,0H383.24a4.28,4.28,0,0,1-.94-.09,3.26,3.26,0,0,1-2.38-2.74,6.35,6.35,0,0,1,0-1v-1a5.24,5.24,0,0,0-.19-1.9,3,3,0,0,0-3-2H361.84a10.28,10.28,0,0,0-4.33.83,9.78,9.78,0,0,0-5.64,6.81c-.1.38-.13.77-.2,1.16s-.05.78-.05,1.18v22.51c0,13.9,0,28.74,0,44.37v49q0,12.75,0,25.94v16.61a10.59,10.59,0,0,0,.4,3.27,9.88,9.88,0,0,0,3.83,5.28,10.2,10.2,0,0,0,6.3,1.74h20l25.93,0h12.63c2.09,0,4.17,0,6.22,0a9.77,9.77,0,0,0,5.58-2.16,10.66,10.66,0,0,0,2-2.23,10,10,0,0,0,1.24-2.72,10.92,10.92,0,0,0,.37-3V269.42c0-31.24,0-59.38.05-83s0-42.76.05-56c0-1.66,0-3.22,0-4.68a10.25,10.25,0,0,0-.72-4,9.89,9.89,0,0,0-1.87-2.94,9.26,9.26,0,0,0-2.24-1.84,9.49,9.49,0,0,0-3.69-1.3,6.54,6.54,0,0,0-1-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.25,131.63s-1.64.09-3.66.11-3.66,0-3.66-.05,1.64-.09,3.66-.11S428.25,131.59,428.25,131.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.27,133.5c0,.05-1.64.09-3.66.11s-3.66,0-3.67-.05,1.64-.09,3.67-.1S428.27,133.46,428.27,133.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,135.38s-1.63.09-3.66.11-3.66,0-3.66-.05,1.64-.09,3.66-.11S428.28,135.34,428.28,135.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.64,137.52s.05,0,.15,0l.42,0,1.57,0,0,0c0-.35,0-.73,0-1.13,0-.22,0-.41,0-.66a.6.6,0,0,1,.52-.48c.25,0,.47,0,.75,0a.6.6,0,0,1,.51.6c0,.53,0,1.08,0,1.65l-.07-.07,2,0-.08.08c0-.79,0-1.62,0-2.46v-.62a.62.62,0,0,0-.28-.47l-.86-.85-.83-.82-.41-.4c-.14-.13-.24-.27-.41-.3a.52.52,0,0,0-.45.08c-.12.1-.25.25-.37.36l-.7.72c-.45.46-.91.88-1.25,1.28a1.42,1.42,0,0,0-.1.74v.69c0,.43,0,.8,0,1.12s0,.53,0,.72v.26a1.1,1.1,0,0,1,0-.24c0-.19,0-.42,0-.71l0-1.12c0-.23,0-.46,0-.71v-.39a.74.74,0,0,1,.11-.41c.36-.45.8-.85,1.25-1.32.22-.24.46-.48.7-.72a4.54,4.54,0,0,1,.38-.38.68.68,0,0,1,.57-.11,1,1,0,0,1,.47.34l.41.39.83.82.87.85a1.74,1.74,0,0,1,.22.24.64.64,0,0,1,.1.33c0,.21,0,.42,0,.63,0,.84,0,1.66,0,2.46v.07h-.08l-2,0h-.07v-.07c0-.58,0-1.13,0-1.66a.48.48,0,0,0-.4-.48h-.72a.48.48,0,0,0-.42.38c0,.2,0,.43,0,.63v1.18h-2.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.46,
    y: 199.95,
    width: 55.84,
    height: 11.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.46,
    y: 216.5,
    width: 55.84,
    height: 11.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.88,250.58h-28a5.71,5.71,0,0,1-5.7-5.71h0a5.7,5.7,0,0,1,5.7-5.7h28a5.7,5.7,0,0,1,5.7,5.7h0A5.71,5.71,0,0,1,407.88,250.58Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.25,171.15c0,.28-7.84.51-17.52.51s-17.52-.23-17.52-.51,7.84-.51,17.52-.51S411.25,170.87,411.25,171.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.07,103.85h-7.18a5.31,5.31,0,0,0-2.16.23,3.37,3.37,0,0,0-1.71,1.52,3.74,3.74,0,0,0-.4,1.15,6.76,6.76,0,0,0-.05,1.28v1.32a7.12,7.12,0,0,1-.09,1.37,3.65,3.65,0,0,1-1.6,2.31,3.45,3.45,0,0,1-1.41.5c-.51,0-1,0-1.52,0h-26a4.12,4.12,0,0,1-1-.1,3.49,3.49,0,0,1-1.79-1.11,3.77,3.77,0,0,1-.87-2,9.75,9.75,0,0,1,0-1.08v-1.07a5.77,5.77,0,0,0-.21-2.12,3.45,3.45,0,0,0-1.28-1.68,3.33,3.33,0,0,0-2.07-.57H309.05a10.94,10.94,0,0,0-8.84,3.92,11.15,11.15,0,0,0-2.28,4.59c-.11.43-.14.86-.22,1.29s0,.74,0,1.11V291.91a11.32,11.32,0,0,0,.45,3.48,10.94,10.94,0,0,0,4.26,5.89,11.37,11.37,0,0,0,7,1.94h22.26l28.92,0h14.09c2.32,0,4.65,0,6.93,0a10.9,10.9,0,0,0,6.22-2.41,11.57,11.57,0,0,0,2.25-2.49,11,11,0,0,0,1.37-3,11.16,11.16,0,0,0,.42-3.3v-3.35q0-6.7,0-13.23c0-34.85,0-66.23.05-92.59s0-47.68.06-62.42c0-1.85,0-3.59,0-5.22a11.36,11.36,0,0,0-.81-4.46,11,11,0,0,0-2.08-3.28,11,11,0,0,0-6.62-3.5,8.49,8.49,0,0,0-1.12-.1l-.38,0h-1.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.06,104h.38a10.1,10.1,0,0,1,1.12.09,10.47,10.47,0,0,1,4.15,1.43,10.75,10.75,0,0,1,2.53,2,11.06,11.06,0,0,1,2.1,3.3,11.34,11.34,0,0,1,.83,4.49c0,1.64,0,3.38,0,5.22,0,14.74,0,36.07,0,62.43s0,57.74,0,92.58v16.58a11.7,11.7,0,0,1-.42,3.38,11.12,11.12,0,0,1-1.42,3.12,11.89,11.89,0,0,1-2.3,2.56,11.25,11.25,0,0,1-6.39,2.48c-2.32.06-4.62,0-6.95,0H309.47a11.65,11.65,0,0,1-7.2-2,11.32,11.32,0,0,1-4.39-6.05,12.21,12.21,0,0,1-.46-3.75V273.37q0-14.7,0-28.93c0-19,0-37.26,0-54.68s0-34,0-49.49c0-7.74,0-15.23,0-22.42v-2.68c0-.45,0-.9.06-1.35s.12-.88.23-1.31a11.32,11.32,0,0,1,2.33-4.69,11.5,11.5,0,0,1,4.1-3.07,11.68,11.68,0,0,1,4.92-.93h16.56a3.53,3.53,0,0,1,2.18.61,3.72,3.72,0,0,1,1.35,1.78,5.8,5.8,0,0,1,.22,2.18v1.08a7.26,7.26,0,0,0,0,1.05,3.55,3.55,0,0,0,.82,1.85,3.28,3.28,0,0,0,1.69,1,3.37,3.37,0,0,0,1,.1h5l14.59,0H359c.5,0,1,0,1.5,0a3.25,3.25,0,0,0,1.36-.47,3.55,3.55,0,0,0,1.55-2.23,6.81,6.81,0,0,0,.09-1.35v-1.32a6.93,6.93,0,0,1,.06-1.29,3.82,3.82,0,0,1,.41-1.19,3.57,3.57,0,0,1,1.77-1.56,5.58,5.58,0,0,1,2.2-.23l7.17,0,4.42,0h1.5l-1.5,0H368a5.5,5.5,0,0,0-2.16.24,3.32,3.32,0,0,0-1.71,1.52,3.28,3.28,0,0,0-.4,1.15,7.56,7.56,0,0,0-.06,1.27v1.32a6.34,6.34,0,0,1-.08,1.37,3.6,3.6,0,0,1-1.6,2.31,3.36,3.36,0,0,1-1.41.5c-.51,0-1,0-1.52,0H333a3.67,3.67,0,0,1-1-.1,3.5,3.5,0,0,1-1.79-1.1,3.69,3.69,0,0,1-.87-2,7.92,7.92,0,0,1,0-1.08v-1.08a5.79,5.79,0,0,0-.21-2.12,3.51,3.51,0,0,0-1.29-1.68,3.3,3.3,0,0,0-2.06-.57H309.13a11.36,11.36,0,0,0-4.83.92,11,11,0,0,0-6.29,7.6c-.11.42-.14.86-.22,1.29s-.05.87-.06,1.32v2.68c0,7.19,0,14.68,0,22.42v133.1c0,4.89,0,9.83,0,14.79v3.73a11.86,11.86,0,0,0,.45,3.66,11,11,0,0,0,4.27,5.89,11.35,11.35,0,0,0,7,1.93h65.28c2.32,0,4.65,0,6.93,0A10.91,10.91,0,0,0,387.9,301a11.78,11.78,0,0,0,2.25-2.48,11.09,11.09,0,0,0,1.37-3,11.81,11.81,0,0,0,.42-3.3V275.57c0-34.84,0-66.23.05-92.58s.05-47.69.07-62.43v-5.22a11.31,11.31,0,0,0-.8-4.45,11.09,11.09,0,0,0-2.08-3.29,10.84,10.84,0,0,0-2.5-2,10.64,10.64,0,0,0-4.12-1.46,8.49,8.49,0,0,0-1.12-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.2,121.89s-1.83.1-4.08.12S375,122,375,122s1.83-.1,4.09-.12S383.2,121.84,383.2,121.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.22,124s-1.83.1-4.09.12-4.08,0-4.08,0,1.83-.1,4.08-.12S383.22,123.93,383.22,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.23,126.07c0,.05-1.82.1-4.08.12s-4.08,0-4.08,0,1.82-.1,4.08-.12S383.23,126,383.23,126.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.9,128.46s.06,0,.17,0l.47,0,1.75,0-.05.05c0-.39,0-.81,0-1.27,0-.23,0-.45,0-.72a.68.68,0,0,1,.59-.54c.28,0,.53,0,.83,0a.68.68,0,0,1,.57.68c0,.59,0,1.2,0,1.84l-.08-.08,2.2,0-.08.09c0-.89,0-1.81,0-2.75V125a.69.69,0,0,0-.31-.52l-1-1-.93-.92-.45-.44c-.15-.15-.28-.31-.46-.34a.59.59,0,0,0-.5.09c-.13.12-.28.28-.41.41l-.79.79c-.5.52-1,1-1.39,1.44a1.51,1.51,0,0,0-.11.82v.77c0,.48,0,.89,0,1.25s0,.58,0,.8a1.43,1.43,0,0,1,0,.29s0-.09,0-.27,0-.47,0-.78,0-.78,0-1.26c0-.25,0-.51,0-.79s0-.29,0-.43a.9.9,0,0,1,.13-.47c.4-.49.89-.94,1.39-1.47l.78-.8a5.75,5.75,0,0,1,.43-.42.75.75,0,0,1,.64-.13,1.28,1.28,0,0,1,.52.38l.45.44.94.92,1,.94a2.21,2.21,0,0,1,.25.27.7.7,0,0,1,.11.37c0,.23,0,.47,0,.7,0,.94,0,1.86,0,2.74v.09h-2.37v-.08c0-.64,0-1.25,0-1.84a.53.53,0,0,0-.44-.54c-.25,0-.55,0-.8,0a.53.53,0,0,0-.47.43,5.45,5.45,0,0,0,0,.7v1.32h0l-1.77,0h-.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.1,
    cy: 169.69,
    r: 18.48,
    transform: "translate(125.44 485.75) rotate(-81.2)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.44,177.15H339.76v-1.56a6.34,6.34,0,0,1,6.34-6.34h0a6.34,6.34,0,0,1,6.34,6.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.1,
    cy: 165.97,
    r: 3.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.17,
    y: 209.33,
    width: 62.28,
    height: 12.72,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.17,
    y: 227.79,
    width: 62.28,
    height: 12.72,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.48,265.79H329.22a6.35,6.35,0,0,1-6.36-6.36h0a6.36,6.36,0,0,1,6.36-6.36h31.26a6.36,6.36,0,0,1,6.36,6.36h0A6.36,6.36,0,0,1,360.48,265.79Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.37,201.67c0,.31-8.75.57-19.54.57s-19.55-.26-19.55-.57,8.75-.58,19.55-.58S364.37,201.35,364.37,201.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.77,218.49H319a.48.48,0,0,1-.49-.48h0a1.83,1.83,0,0,1,1.83-1.84h.06a1.84,1.84,0,0,1,1.84,1.84h0A.48.48,0,0,1,321.77,218.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.49,215.21a1.1,1.1,0,1,1-1.1-1.1A1.09,1.09,0,0,1,321.49,215.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.75,
    y: 234.35,
    width: 3.28,
    height: 2.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.4,234.85h-1.1v-.72a.93.93,0,0,0-1.86,0v.72h-1.1v-.72a2,2,0,1,1,4.06,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.11,64.81l-10.69,0a8.06,8.06,0,0,0-3.22.35,5,5,0,0,0-2.54,2.26,5.27,5.27,0,0,0-.6,1.71A9.87,9.87,0,0,0,292,71v2a8.79,8.79,0,0,1-.13,2,5.38,5.38,0,0,1-2.38,3.44,5.05,5.05,0,0,1-2.1.75c-.76.06-1.5,0-2.27,0H246.33a5.87,5.87,0,0,1-1.55-.15,5.08,5.08,0,0,1-2.66-1.65,5.35,5.35,0,0,1-1.3-2.9,10.8,10.8,0,0,1-.06-1.6V71.37a8.53,8.53,0,0,0-.32-3.15,5.14,5.14,0,0,0-1.91-2.5,5,5,0,0,0-3.08-.85H210.79a16.36,16.36,0,0,0-13.17,5.84,16.56,16.56,0,0,0-3.39,6.84c-.16.62-.21,1.28-.33,1.92s-.05,1.09-.07,1.64v263.6a17.13,17.13,0,0,0,.66,5.19,16.41,16.41,0,0,0,6.35,8.76,16.94,16.94,0,0,0,10.47,2.88h33.15l43.07,0h21c3.45,0,6.92.06,10.33,0a16.21,16.21,0,0,0,9.26-3.59,17.53,17.53,0,0,0,3.34-3.7,16.18,16.18,0,0,0,2.05-4.52,17.27,17.27,0,0,0,.62-4.91v-5q0-10,0-19.68c0-51.87.05-98.57.07-137.8s.08-71,.1-92.91c0-2.75,0-5.34,0-7.77a17,17,0,0,0-1.2-6.63,16.32,16.32,0,0,0-3.1-4.89,15.55,15.55,0,0,0-3.72-3A15.77,15.77,0,0,0,320.15,65a13.39,13.39,0,0,0-1.67-.15l-.56,0-2.24,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.08,64.87l.57,0a12.19,12.19,0,0,1,1.66.12,15.67,15.67,0,0,1,6.17,2.13,15.91,15.91,0,0,1,3.75,3,16.36,16.36,0,0,1,3.13,4.91,17.12,17.12,0,0,1,1.23,6.67c0,2.43,0,5,0,7.75,0,21.9,0,53.59,0,92.74s0,85.78,0,137.54v24.64a17.71,17.71,0,0,1-.63,5,16.83,16.83,0,0,1-2.1,4.63,17.67,17.67,0,0,1-3.42,3.8,16.64,16.64,0,0,1-9.5,3.69c-3.44.1-6.87,0-10.33,0H287.77l-43,0H211.74a17.41,17.41,0,0,1-10.71-3,16.8,16.8,0,0,1-6.51-9,18.09,18.09,0,0,1-.69-5.56V338.5q0-11.07,0-22,0-21.82,0-43c0-28.17,0-55.34,0-81.23s0-50.49,0-73.51q0-17.26,0-33.32c0-1.33,0-2.66,0-4,0-.66.05-1.33.09-2s.16-1.32.33-2a17,17,0,0,1,3.46-7,16.68,16.68,0,0,1,13.41-5.94l14.32,0h10.27a5.25,5.25,0,0,1,3.24.9,5.44,5.44,0,0,1,2,2.65,8.74,8.74,0,0,1,.33,3.24v1.6a11.61,11.61,0,0,0,0,1.57,5.16,5.16,0,0,0,1.23,2.75,4.86,4.86,0,0,0,2.51,1.56,6.1,6.1,0,0,0,1.48.15h7.45l21.67,0h9.56c.75,0,1.52,0,2.24,0a4.88,4.88,0,0,0,2-.7,5.17,5.17,0,0,0,2.3-3.31,8.93,8.93,0,0,0,.13-2c0-.67,0-1.32,0-2a11.06,11.06,0,0,1,.08-1.91,5.5,5.5,0,0,1,.62-1.76,5.19,5.19,0,0,1,2.63-2.32,8.17,8.17,0,0,1,3.26-.35l10.66,0,6.56,0,2.23,0-2.23,0-6.56,0-10.66,0a8.18,8.18,0,0,0-3.21.34,5.11,5.11,0,0,0-2.54,2.26,5.43,5.43,0,0,0-.59,1.71,9.87,9.87,0,0,0-.08,1.89v2a8.74,8.74,0,0,1-.13,2,5.38,5.38,0,0,1-2.38,3.44,5.08,5.08,0,0,1-2.09.74c-.76.07-1.5,0-2.26,0H246.67a5.76,5.76,0,0,1-1.54-.16,5.13,5.13,0,0,1-2.66-1.64,5.5,5.5,0,0,1-1.3-2.89,12.48,12.48,0,0,1,0-1.61v-1.6a8.75,8.75,0,0,0-.32-3.15,5.11,5.11,0,0,0-1.91-2.49,5,5,0,0,0-3.07-.85h-24.6a16.31,16.31,0,0,0-13.13,5.83,16.34,16.34,0,0,0-3.38,6.82c-.17.63-.22,1.28-.33,1.92s-.08,1.3-.09,2v4q0,16,0,33.32c0,23,0,47.62,0,73.51s0,53.06,0,81.23v43q0,10.91,0,22V344a18.06,18.06,0,0,0,.67,5.43,16.36,16.36,0,0,0,6.34,8.75,16.86,16.86,0,0,0,10.44,2.87h33.07l43,0H308.7c3.45,0,6.91.06,10.31,0a16.11,16.11,0,0,0,9.23-3.58,17.26,17.26,0,0,0,3.34-3.7,16,16,0,0,0,2-4.51,16.83,16.83,0,0,0,.62-4.89v-5q0-9.93,0-19.65c0-51.76.05-98.38.08-137.54s.07-70.84.09-92.74c0-2.74,0-5.32,0-7.75a16.87,16.87,0,0,0-1.2-6.62,16.25,16.25,0,0,0-3.09-4.88,15.81,15.81,0,0,0-3.71-3,15.6,15.6,0,0,0-6.12-2.16,13.42,13.42,0,0,0-1.66-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.26,91.49c0,.07-2.71.15-6.06.18s-6.07,0-6.07-.08,2.71-.15,6.06-.18S321.26,91.42,321.26,91.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.29,94.6c0,.07-2.72.15-6.07.17s-6.07,0-6.07-.07,2.72-.15,6.07-.18S321.29,94.52,321.29,94.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.31,97.7c0,.07-2.71.15-6.06.18s-6.07,0-6.07-.08,2.71-.15,6.06-.18S321.31,97.63,321.31,97.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.88,101.24h.26l.7,0,2.59-.06-.07.08c0-.58,0-1.21,0-1.88,0-.35,0-.68,0-1.09a1,1,0,0,1,.87-.79c.42,0,.79,0,1.24,0a1,1,0,0,1,.85,1c0,.88,0,1.79,0,2.74l-.12-.12,3.27,0-.13.13q0-2,0-4.08c0-.35,0-.69,0-1a1.08,1.08,0,0,0-.46-.78l-1.43-1.41L217,92.51l-.67-.66c-.23-.22-.41-.45-.67-.5a.9.9,0,0,0-.75.14c-.2.17-.41.41-.61.6l-1.17,1.18c-.74.77-1.51,1.47-2.07,2.13a2.31,2.31,0,0,0-.16,1.22v1.15c0,.71,0,1.33,0,1.86s0,.87,0,1.19a2,2,0,0,1,0,.42s0-.12,0-.39,0-.7,0-1.17,0-1.16,0-1.87c0-.37,0-.76,0-1.17,0-.21,0-.43,0-.64a1.21,1.21,0,0,1,.18-.69c.6-.74,1.32-1.4,2.07-2.18l1.16-1.2c.21-.2.38-.41.63-.62a1.14,1.14,0,0,1,.95-.19,1.75,1.75,0,0,1,.78.56l.67.66c.46.44.92.9,1.39,1.36L220,95.1a2.88,2.88,0,0,1,.36.4,1.06,1.06,0,0,1,.18.55v1c0,1.4,0,2.76,0,4.07v.13h-.13l-3.27,0h-.12v-.12c0-1,0-1.86,0-2.74a.8.8,0,0,0-.66-.79c-.38,0-.82,0-1.19,0a.81.81,0,0,0-.7.64c0,.33,0,.71,0,1v2h-.07l-2.63,0h-.69A1,1,0,0,1,210.88,101.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.01,
    y: 117.65,
    width: 114.62,
    height: 20.85,
    rx: 8.79,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.83,138.5l.66-.05a8.72,8.72,0,0,0,4.65-1.82,8.67,8.67,0,0,0,2.61-3.31,8.24,8.24,0,0,0,.69-2.43,21.46,21.46,0,0,0,.08-2.81,18.67,18.67,0,0,0-.13-3.06,8.8,8.8,0,0,0-1.14-3,8.68,8.68,0,0,0-5.78-4,23.72,23.72,0,0,0-4-.15h-4.23l-90.45.06a8.59,8.59,0,0,0-8.54,7.86c-.08,1,0,2.14,0,3.2a10,10,0,0,0,.32,3.1,8.71,8.71,0,0,0,3.56,4.86,8.29,8.29,0,0,0,2.77,1.18,13.2,13.2,0,0,0,3,.23h17.82l40.66,0,27.41.07,7.46,0,1.93,0,.66,0s-.22,0-.66,0l-1.93,0-7.46,0-27.41.06-40.66,0H215.89a13.12,13.12,0,0,1-3.11-.23,8.83,8.83,0,0,1-2.91-1.24,9,9,0,0,1-3.73-5.1,10.27,10.27,0,0,1-.34-3.21c0-1.08,0-2.12,0-3.23a9,9,0,0,1,9-8.26l90.45.06h4.23a24.6,24.6,0,0,1,4,.17,8.94,8.94,0,0,1,7.09,7.31,19.18,19.18,0,0,1,.12,3.09,23.72,23.72,0,0,1-.1,2.83,8.66,8.66,0,0,1-.72,2.47,8.82,8.82,0,0,1-2.69,3.35,9,9,0,0,1-2.81,1.43,8.8,8.8,0,0,1-1.91.33C312.06,138.51,311.83,138.5,311.83,138.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.6,127.58s0-.33-.2-.9a3.74,3.74,0,0,0-1.38-2,3.59,3.59,0,1,0,0,5.76,3.71,3.71,0,0,0,1.38-2c.17-.56.16-.9.2-.9s0,.08,0,.24a2.79,2.79,0,0,1-.06.7,3.73,3.73,0,0,1-1.37,2.18,3.9,3.9,0,0,1-3.73.61,4,4,0,0,1,0-7.46,3.92,3.92,0,0,1,3.73.61,3.76,3.76,0,0,1,1.37,2.18,2.79,2.79,0,0,1,.06.7Q313.63,127.58,313.6,127.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.68,134.09a7.62,7.62,0,0,1-1.85-1.68,7.36,7.36,0,0,1-1.53-2,7.6,7.6,0,0,1,1.85,1.69A7.41,7.41,0,0,1,315.68,134.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.48,126h-2v-.53h4.7V126h-2v5.29h-.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.35,129.28h-3.66a1.62,1.62,0,0,0,1.72,1.52,1.71,1.71,0,0,0,1.34-.58l.33.39a2.31,2.31,0,0,1-4-1.52,2.11,2.11,0,0,1,2.14-2.22,2.08,2.08,0,0,1,2.11,2.22Zm-3.66-.44h3.1a1.55,1.55,0,0,0-3.1,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.22,131.28l-1.39-1.83-1.4,1.83h-.66L230.5,129l-1.65-2.13h.67l1.31,1.71,1.31-1.71h.65L231.15,129l1.74,2.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.18,131a1.43,1.43,0,0,1-.93.31,1.16,1.16,0,0,1-1.28-1.27v-2.64h-.78v-.5H234v-1h.59v1h1.33v.5h-1.33V130a.7.7,0,0,0,.76.79,1,1,0,0,0,.65-.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.19,158.36c0,.12-8.39.21-18.73.21s-18.74-.09-18.74-.21,8.39-.22,18.74-.22S284.19,158.24,284.19,158.36Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07,166.05c0,.12-15.08.21-33.67.21s-33.68-.09-33.68-.21,15.08-.22,33.68-.22S314.07,165.93,314.07,166.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.28,171.54c0,.12-14.9.21-33.28.21s-33.28-.09-33.28-.21,14.9-.21,33.28-.21S313.28,171.42,313.28,171.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,176.78c0,.12-8.8.21-19.65.21s-19.65-.09-19.65-.21,8.8-.21,19.65-.21S286,176.66,286,176.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.19,200.16c0,.11-8.39.21-18.73.21s-18.74-.1-18.74-.21,8.39-.22,18.74-.22S284.19,200,284.19,200.16Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07,207.85c0,.11-15.08.21-33.67.21s-33.68-.1-33.68-.21,15.08-.22,33.68-.22S314.07,207.73,314.07,207.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.28,213.34c0,.12-14.9.21-33.28.21s-33.28-.09-33.28-.21,14.9-.22,33.28-.22S313.28,213.22,313.28,213.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,218.58c0,.11-8.8.21-19.65.21s-19.65-.1-19.65-.21,8.8-.22,19.65-.22S286,218.46,286,218.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.19,242c0,.12-8.39.22-18.73.22s-18.74-.1-18.74-.22,8.39-.21,18.74-.21S284.19,241.84,284.19,242Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07,249.64c0,.12-15.08.22-33.67.22s-33.68-.1-33.68-.22,15.08-.21,33.68-.21S314.07,249.53,314.07,249.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.28,255.14c0,.11-14.9.21-33.28.21s-33.28-.1-33.28-.21,14.9-.22,33.28-.22S313.28,255,313.28,255.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,260.37c0,.12-8.8.22-19.65.22s-19.65-.1-19.65-.22,8.8-.21,19.65-.21S286,260.26,286,260.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.19,283.75c0,.12-8.39.21-18.73.21s-18.74-.09-18.74-.21,8.39-.21,18.74-.21S284.19,283.63,284.19,283.75Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07,291.44c0,.12-15.08.21-33.67.21s-33.68-.09-33.68-.21,15.08-.21,33.68-.21S314.07,291.32,314.07,291.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.28,296.93c0,.12-14.9.22-33.28.22s-33.28-.1-33.28-.22,14.9-.21,33.28-.21S313.28,296.82,313.28,296.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,302.17c0,.12-8.8.22-19.65.22s-19.65-.1-19.65-.22,8.8-.21,19.65-.21S286,302.05,286,302.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.19,325.26c0,.11-8.39.21-18.73.21s-18.74-.1-18.74-.21,8.39-.22,18.74-.22S284.19,325.14,284.19,325.26Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07,333c0,.11-15.08.21-33.67.21s-33.68-.1-33.68-.21,15.08-.22,33.68-.22S314.07,332.83,314.07,333Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.28,338.44c0,.12-14.9.21-33.28.21s-33.28-.09-33.28-.21,14.9-.21,33.28-.21S313.28,338.32,313.28,338.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,343.68c0,.12-8.8.21-19.65.21s-19.65-.09-19.65-.21,8.8-.22,19.65-.22S286,343.56,286,343.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.32,
    y: 154.34,
    width: 22.94,
    height: 30.52,
    transform: "translate(50.95 390.44) rotate(-89.68)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 180.99 217.2 166.79 223.76 175.75 228.26 171 236.99 181.16 206.46 180.99",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,165.09a2.41,2.41,0,1,1-2.39-2.41A2.4,2.4,0,0,1,226.62,165.09Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 180.99 217.2 166.79 223.76 175.75 228.26 171 236.99 181.16 206.46 180.99"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.62,165.09a2.41,2.41,0,1,1-2.39-2.41A2.4,2.4,0,0,1,226.62,165.09Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 210.32,
    y: 195.61,
    width: 22.94,
    height: 30.52,
    transform: "translate(9.69 431.48) rotate(-89.68)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 222.25 217.2 208.05 223.76 217.01 228.26 212.27 236.99 222.43 206.46 222.25",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,206.36a2.41,2.41,0,1,1-2.39-2.42A2.4,2.4,0,0,1,226.62,206.36Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 222.25 217.2 208.05 223.76 217.01 228.26 212.27 236.99 222.43 206.46 222.25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M226.62,206.36a2.41,2.41,0,1,1-2.39-2.42A2.4,2.4,0,0,1,226.62,206.36Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 210.32,
    y: 236.87,
    width: 22.94,
    height: 30.52,
    transform: "translate(-31.58 472.52) rotate(-89.68)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 263.52 217.2 249.32 223.76 258.28 228.26 253.53 236.99 263.69 206.46 263.52",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,247.63a2.41,2.41,0,1,1-2.39-2.42A2.42,2.42,0,0,1,226.62,247.63Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 263.52 217.2 249.32 223.76 258.28 228.26 253.53 236.99 263.69 206.46 263.52"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.62,247.63a2.41,2.41,0,1,1-2.39-2.42A2.42,2.42,0,0,1,226.62,247.63Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 210.32,
    y: 278.14,
    width: 22.94,
    height: 30.52,
    transform: "translate(-72.84 513.55) rotate(-89.68)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 304.79 217.2 290.59 223.76 299.55 228.26 294.8 236.99 304.96 206.46 304.79",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,288.89a2.41,2.41,0,1,1-2.39-2.41A2.4,2.4,0,0,1,226.62,288.89Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 304.79 217.2 290.59 223.76 299.55 228.26 294.8 236.99 304.96 206.46 304.79"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.62,288.89a2.41,2.41,0,1,1-2.39-2.41A2.4,2.4,0,0,1,226.62,288.89Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 210.32,
    y: 319.2,
    width: 22.94,
    height: 30.52,
    transform: "translate(-113.91 554.39) rotate(-89.68)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 345.85 217.2 331.65 223.76 340.61 228.26 335.87 236.99 346.02 206.46 345.85",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,330a2.41,2.41,0,1,1-2.39-2.42A2.42,2.42,0,0,1,226.62,330Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 345.85 217.2 331.65 223.76 340.61 228.26 335.87 236.99 346.02 206.46 345.85"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.62,330a2.41,2.41,0,1,1-2.39-2.42A2.42,2.42,0,0,1,226.62,330Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 436.02,
    cy: 118.74,
    r: 10.88,
    transform: "translate(220.72 516.04) rotate(-76.78)",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.36,122.28a.47.47,0,0,1-.31-.12l-3.67-3a.5.5,0,0,1,.64-.78l3.27,2.7,4.65-5.69a.52.52,0,0,1,.71-.07.5.5,0,0,1,.07.7l-5,6.08a.48.48,0,0,1-.34.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.07,
    cy: 103.82,
    r: 14.92,
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.17,109a1,1,0,0,1-.63-.22l-5-4.14a1,1,0,0,1-.14-1.4,1,1,0,0,1,1.41-.14l4.24,3.49L394.21,99a1,1,0,0,1,1.4-.14,1,1,0,0,1,.14,1.41l-6.8,8.33a1.06,1.06,0,0,1-.68.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.79,306.42a31.08,31.08,0,0,1-22-36c-.28.76-.55,1.54-.78,2.34a31.1,31.1,0,0,0,59.82,17c.23-.8.41-1.61.57-2.41A31.08,31.08,0,0,1,325.79,306.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.12,251.46a31.1,31.1,0,0,1,22,36c.28-.77.55-1.55.77-2.35a31.09,31.09,0,1,0-59.81-17c-.23.8-.41,1.6-.57,2.41A31.08,31.08,0,0,1,341.12,251.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.23,284.91s0-.17.09-.5.17-.83.3-1.44c.07-.32.15-.68.24-1.07s.1-.83.16-1.3a23.41,23.41,0,0,0,.25-3.26,29.76,29.76,0,0,0-1.07-8.87,31,31,0,0,0-16.1-19.68,30.18,30.18,0,0,0-3.64-1.5c-.63-.2-1.26-.45-1.91-.62l-2-.46c-.33-.07-.66-.16-1-.21l-1-.13c-.69-.08-1.38-.19-2.09-.24a32.37,32.37,0,0,0-4.29,0,32.7,32.7,0,0,0-4.35.6c-.72.17-1.43.39-2.16.58a16.87,16.87,0,0,0-2.14.73,34.7,34.7,0,0,0-4.18,1.9,34.27,34.27,0,0,0-3.88,2.62,29.8,29.8,0,0,0-6.56,7,30.63,30.63,0,0,0-5.33,18.72,29.86,29.86,0,0,0,1.92,9.38,32.8,32.8,0,0,0,1.93,4.26,33.84,33.84,0,0,0,2.55,3.82,16.13,16.13,0,0,0,1.44,1.75c.52.54,1,1.11,1.53,1.63a33.12,33.12,0,0,0,3.39,2.8,33.93,33.93,0,0,0,3.63,2.29c.62.32,1.27.59,1.9.89l.95.43c.32.14.65.23,1,.35l1.94.66c.64.19,1.31.32,1.95.48a27.73,27.73,0,0,0,3.88.63,31.07,31.07,0,0,0,24.05-8.27,29.48,29.48,0,0,0,5.57-7,22.61,22.61,0,0,0,1.5-2.91c.2-.43.4-.82.55-1.19l.36-1c.22-.59.38-1.06.5-1.39s.19-.47.19-.47,0,.17-.14.49-.26.8-.45,1.41c-.1.31-.21.65-.34,1s-.34.78-.53,1.21a21.6,21.6,0,0,1-1.46,2.95,29.82,29.82,0,0,1-5.55,7.09,31.23,31.23,0,0,1-24.29,8.48,28.42,28.42,0,0,1-3.93-.63c-.66-.16-1.33-.28-2-.48l-2-.66c-.32-.12-.66-.21-1-.35l-1-.44c-.64-.3-1.3-.57-1.93-.9A34.89,34.89,0,0,1,316,301.8a32.9,32.9,0,0,1-3.45-2.84c-.54-.53-1-1.1-1.56-1.65a16.53,16.53,0,0,1-1.46-1.77,34.53,34.53,0,0,1-2.6-3.88,36.06,36.06,0,0,1-2-4.33,30.19,30.19,0,0,1-2-9.54,30.88,30.88,0,0,1,5.41-19,30.24,30.24,0,0,1,6.68-7.08,34.47,34.47,0,0,1,3.95-2.65,37.39,37.39,0,0,1,4.24-1.93,17.43,17.43,0,0,1,2.18-.73c.74-.19,1.46-.42,2.2-.58a32.15,32.15,0,0,1,4.42-.61,33.26,33.26,0,0,1,4.35,0c.72.05,1.42.17,2.13.25l1,.13c.35.05.69.15,1,.23l2,.46c.66.18,1.3.43,1.94.64a30,30,0,0,1,3.68,1.54,31.25,31.25,0,0,1,16.19,20,29.26,29.26,0,0,1,1,8.94,21.5,21.5,0,0,1-.3,3.28c-.07.47-.11.91-.19,1.31s-.18.74-.25,1.06q-.24.92-.36,1.44C364.28,284.75,364.23,284.91,364.23,284.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.41,302.64c.4.27,29.84,27.42,40.68,37.58a4.71,4.71,0,0,0,6.51-.06h0a4.71,4.71,0,0,0-.06-6.84L359.13,296Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.15,204.11l.6-2.36a9,9,0,0,0-.1-4.71l-2.47-8.24a3.1,3.1,0,0,0-1.42-1.79c-1.88-1.08-5.59-3.16-5.91-2.9-2.27,1.89,2.81,5.22,2.81,5.22s2,2.19.41,3.81c-1.77,1.84-5.08-2.2-5.08-2.2s.17-.42.33-.34a6.58,6.58,0,0,0,3.19,1.37v-2.68l-3-1.88a3,3,0,0,0-2.23-.4l-1,.23a2.62,2.62,0,0,0-1.64,1.11l-1,1.48-.42.57a1.88,1.88,0,0,0-.2,1.9l.48,1-.66.92a2.83,2.83,0,0,0-.33,2.64l5.07,7,7.5,12.25,8.12-8.72Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.43,196.87a1.57,1.57,0,0,1-.27-.51,1.41,1.41,0,0,1,.24-1.3l0,0,0-.06-.08-.18a12.13,12.13,0,0,0-1.09-2,13.28,13.28,0,0,0,.91,2.07l.09.18v-.11a1.47,1.47,0,0,0-.22,1.47C185.18,196.77,185.42,196.9,185.43,196.87Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.05,187.78a2.28,2.28,0,0,0-.16,1.4,10.75,10.75,0,0,0,1.37,3.23,4.13,4.13,0,0,1,.47.94,2.47,2.47,0,0,1,.06,1,2.48,2.48,0,0,0,.18,1.5,3,3,0,0,0,1,1,1.66,1.66,0,0,1-1.17-.92,2.45,2.45,0,0,1-.27-1.62,2.66,2.66,0,0,0-.07-.89,4.25,4.25,0,0,0-.45-.87,9.48,9.48,0,0,1-1.32-3.35C185.54,188.24,186,187.73,186.05,187.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.05,190.82a6.35,6.35,0,0,0-.38-1.12c-.31-.58-.64-1-.57-1.08s.51.3.85.94S190.15,190.86,190.05,190.82Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.93 246.01 207.02 249.89 223.08 230.6 202.05 202.94 191.66 211.09 203.93 246.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.37 432.66 276.7 464 293.63 463.62 292.36 432.22 275.37 432.66",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,462.63c.14,0-.12-6.87-.58-15.33s-1-15.31-1.1-15.3.12,6.87.59,15.33S284.87,462.64,285,462.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.61 461.84 293.54 461.41 293.63 463.62 276.7 464 276.61 461.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.22,453.59s-.13-.27-.46-.67a11.71,11.71,0,0,0-1.58-1.54,12,12,0,0,0-2.82-1.71,9,9,0,0,0-10.44,2.45,7.68,7.68,0,0,0-1.16,1.89,2.27,2.27,0,0,0-.23.78,18.51,18.51,0,0,1,1.66-2.44,9,9,0,0,1,6.22-2.89,10.26,10.26,0,0,1,6.54,2.21C292.42,452.75,293.15,453.65,293.22,453.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.72 441.15 292.86 444.61 275.89 444.91 275.78 442.31 292.72 441.15"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M235.53,434.53l.83,19.08s-19.11,7.25-19.3,10.79l37-.27L254,434.35Z",
    style: {
      fill: "#8592F3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.56,452a1.51,1.51,0,0,1,1.06,1.73,1.47,1.47,0,0,1-1.7,1.08A1.6,1.6,0,0,1,245.8,453a1.51,1.51,0,0,1,1.9-.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1,464.12v-3l-35.85,1.36s-1.66.73-1.46,1.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,453.74c0,.18.92.25,1.82.83s1.39,1.34,1.55,1.27-.11-1.12-1.21-1.8S236,453.57,236,453.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.12,455.38c0,.18.75.48,1.38,1.25s.81,1.58,1,1.57.29-1-.51-2S232.13,455.21,232.12,455.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.93,460.08c.17,0,.42-.87-.06-1.87s-1.33-1.38-1.4-1.23.45.68.83,1.51S229.75,460.07,229.93,460.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.32,449.34c.08.16.91-.1,1.94,0s1.84.38,1.93.22-.68-.8-1.9-.86S236.23,449.19,236.32,449.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.63,445.23a3.44,3.44,0,0,0,1.86,0,8.52,8.52,0,0,0,1.95-.62,7.46,7.46,0,0,0,1.07-.58,2.11,2.11,0,0,0,.56-.44.77.77,0,0,0,.08-1,1,1,0,0,0-.8-.41,2.36,2.36,0,0,0-.7.1,7.52,7.52,0,0,0-1.16.41,6.43,6.43,0,0,0-1.71,1.14c-.86.81-1.15,1.49-1.09,1.53s.5-.52,1.37-1.18a7.56,7.56,0,0,1,1.66-1,7.39,7.39,0,0,1,1.07-.33c.4-.11.74-.12.84.06s0,.09,0,.21a2.09,2.09,0,0,1-.41.32,8.37,8.37,0,0,1-1,.57,10.09,10.09,0,0,1-1.8.71A12.56,12.56,0,0,0,235.63,445.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,445.49c.07,0,.43-.63.48-1.81a5.77,5.77,0,0,0-.27-2,5.25,5.25,0,0,0-.48-1.13,1.55,1.55,0,0,0-1.2-.94.89.89,0,0,0-.78.53,2.46,2.46,0,0,0-.18.68,3.79,3.79,0,0,0,0,1.26,4.27,4.27,0,0,0,.81,1.93c.73,1,1.5,1.17,1.51,1.11s-.58-.44-1.14-1.36a4.1,4.1,0,0,1-.58-2.84c.06-.39.2-.71.35-.67s.5.29.66.6a7,7,0,0,1,.47,1,6.69,6.69,0,0,1,.38,1.86C236,444.78,235.77,445.46,235.86,445.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.11 445.79 254.07 450.02 236.2 450.02 236.2 446.18 254.11 445.79"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M314,128.29l2.65,10.28s1,5.68-1.66,5.67c-2.34,0-2.57-3.05-2.57-3.05s1.17-6.22-1.89-5.87c-.43.05-1.55,4.34-2.09,6.52a3.24,3.24,0,0,0,.32,2.36l4.41,7.81a9.37,9.37,0,0,0,3.46,3.47l2.21,1.25.29,4.64,12.41.2-3.78-14.48-1.58-8.83a3,3,0,0,0-2.22-1.65l-1.17-.17-.44-1.12a2,2,0,0,0-1.58-1.22l-.72-.09-1-2.51c-.34-.83-2.77-6.3-3.67-6.29C315.37,125.21,313.35,125.76,314,128.29Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,140.74a8.28,8.28,0,0,0-.23-1.13,4.32,4.32,0,0,0-1.69-2.15,12,12,0,0,1-.93-2.69,3.32,3.32,0,0,1-.13-1.17s.08.44.27,1.13a16.38,16.38,0,0,0,1,2.6c.18.16.4.32.61.5a3.94,3.94,0,0,1,1.06,1.74,3.1,3.1,0,0,1,.12.85A.9.9,0,0,1,322.86,140.74Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.75,139.69a1.7,1.7,0,0,0-.18-.56,1.46,1.46,0,0,0-1.15-.75h-.07l0-.06-.07-.19a13.35,13.35,0,0,1-.71-2.25,12.34,12.34,0,0,1,.9,2.17l.08.2-.09-.07a1.55,1.55,0,0,1,1.26.89C324.86,139.44,324.78,139.71,324.75,139.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.69,189.42l22.51-.29L271.69,170s1.54-.33,1.64-8.67.49-22.5.49-22.5h0a29,29,0,0,0-29.12,3.66l-1.24.95Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.08,153.67c-.14-.06-5.73-1.7-5.55,4s5.87,4.34,5.87,4.18S246.08,153.67,246.08,153.67Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.85,152.48c.14-.07,5.22-1.44,5,4.26s-5.87,4.35-5.87,4.18S272.85,152.48,272.85,152.48Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.23,153c.85,4.78.68,7.29,1.47,10.48,1.25,5,3.75,8.92,8.3,11.44s10.7,2.47,14.61-1c2.71-2.38,4.63-5.07,5-8.66s.81-9.94.83-13.54c0-6.51.49-12.73.49-12.73l-18.6-3.37L245.78,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.41,177.83a8.38,8.38,0,0,1-6.38-.71c.06-.14,1.43.29,3.18.48A30.84,30.84,0,0,1,263.41,177.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.13,161.15c-.55-4.89-.9-10.49-1.67-15.65-.28-1.94-1-4.73-.8-6.68a16.1,16.1,0,0,1,1.22-5.73,8.05,8.05,0,0,1,12.55-2.53,6,6,0,0,1,11,2.55,4.19,4.19,0,0,1,6.92,4.2,4.09,4.09,0,0,1,2.76,6.27c-.86,1.33-2.41,2.06-3.36,3.32a4.78,4.78,0,0,0-.29,5.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,143.46a1.44,1.44,0,0,1-.21.54,3.75,3.75,0,0,1-1.08,1.21,3.88,3.88,0,0,1-2.42.77,4.11,4.11,0,0,1-3-1.4l.39-.1a3.86,3.86,0,0,1-2.48,2.85,4.43,4.43,0,0,1-4.19-.53,6.27,6.27,0,0,1-2.36-3.09l.45,0a5.25,5.25,0,0,1-4.21,2.31,4.83,4.83,0,0,1-3.54-1.45,5,5,0,0,1-1.29-2.18,1.84,1.84,0,0,1-.1-.9s.07.31.27.85a5.18,5.18,0,0,0,1.34,2,4.58,4.58,0,0,0,3.3,1.24,4.81,4.81,0,0,0,3.8-2.14l.28-.43.17.48a5.94,5.94,0,0,0,2.18,2.83,4,4,0,0,0,3.72.49,3.45,3.45,0,0,0,2.22-2.46l.09-.47.3.36a3.81,3.81,0,0,0,2.66,1.32,3.7,3.7,0,0,0,2.25-.61A5.34,5.34,0,0,0,271,143.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.91,141.2a5.09,5.09,0,0,0-.79-2.07,3.41,3.41,0,0,0-2-1.32,3.5,3.5,0,0,0-2.83.55l-.45.32,0-.56a4.06,4.06,0,0,0-.19-1.64,4.47,4.47,0,0,0-2.28-2.66,4.38,4.38,0,0,0-2.9-.25,6.26,6.26,0,0,0-2.42,1.36,1.71,1.71,0,0,1,.46-.63,4.53,4.53,0,0,1,1.86-1.09,4.61,4.61,0,0,1,3.2.18,4.81,4.81,0,0,1,2.58,2.94,4.64,4.64,0,0,1,.2,1.84l-.4-.23a4,4,0,0,1,3.25-.56,3.66,3.66,0,0,1,2.68,3.2C271,141,270.94,141.21,270.91,141.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.06,141.37c-.07,0,0-.32,0-.78a3.66,3.66,0,0,0-.58-1.69c-.37-.59-.82-1.19-1.07-1.51a.54.54,0,0,0-.6-.11s0-.13.12-.23a.63.63,0,0,1,.7,0,5,5,0,0,1,.65.65,8.39,8.39,0,0,1,.65.88,3.13,3.13,0,0,1,.5,2C259.34,141.14,259.11,141.4,259.06,141.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,134.2c-.06,0,0-.44.35-1a2.78,2.78,0,0,1,.84-.89,2.2,2.2,0,0,1,1.51-.33,3.61,3.61,0,0,1,2.26,1.41c.42.53.61.89.56.94s-.36-.24-.83-.68a3.86,3.86,0,0,0-2.05-1.15,2.14,2.14,0,0,0-2,.92C248.28,133.86,248.1,134.23,248,134.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92,158.38a12.73,12.73,0,0,1-2.65-7.72c.15,0,.45,1.79,1.18,3.91S251.06,158.3,250.92,158.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.42,159.74a6.73,6.73,0,0,1-1.38-2.59,7,7,0,0,1-.68-2.85,10.81,10.81,0,0,1,1.17,2.67A10.8,10.8,0,0,1,253.42,159.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08,160.13a10.89,10.89,0,0,1-3.47,9.19A31.51,31.51,0,0,0,268,165,30.52,30.52,0,0,0,269.08,160.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.58,156a7.31,7.31,0,0,1,.36,4.52,7.21,7.21,0,0,1-1.93,4.09,25.14,25.14,0,0,0,1.42-4.19A24.93,24.93,0,0,0,271.58,156Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "264.38 313.1 269.85 365.86 273.78 445.32 294.75 445.32 295.32 276.2 235.28 280.49 222.84 369.22 233.62 446.87 256.62 446.87 251.24 373.03 264.38 313.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38,313.1a63.57,63.57,0,0,1-8.51,7.66,32.06,32.06,0,0,1,4.08-4A31.26,31.26,0,0,1,264.38,313.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.32,312a60.58,60.58,0,0,1,.11-6.77,58.87,58.87,0,0,1,.39-6.76,36.13,36.13,0,0,1,.13,6.78A35.42,35.42,0,0,1,264.32,312Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,292.35a1.57,1.57,0,0,1,.34,0l1-.06,4-.19,14.22-.6h.24v.25c0,4.43,0,9.45,0,14.76v.46l-.17.06-9.25,3.71-.08,0-.09,0-8.17-2.84-.13,0,0-.13c-.6-4.61-1.1-8.45-1.45-11.2-.16-1.28-.28-2.31-.38-3.08a8.53,8.53,0,0,1-.1-1,2.18,2.18,0,0,1,.07.3c0,.23.08.5.14.83.12.78.28,1.82.49,3.12.41,2.71,1,6.48,1.66,11l-.14-.17,8.19,2.78h-.17l9.24-3.73-.16.24v-.28c0-5.31,0-10.33,0-14.76l.24.23-14.06.35-4,.07h-1.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,292.61a1.11,1.11,0,0,1,.31,0l.93-.05,3.6-.11,13-.3H259v.24c-.14,4.38-.3,9.43-.47,14.8v.14l-.11.07-1.5,1-7.6,5-.14.09-.13-.09-8.56-5.21-.11-.07v-.12c.16-4.6.3-8.43.39-11.18.06-1.28.1-2.31.14-3.08a9.34,9.34,0,0,1,.07-1,1,1,0,0,1,0,.3v.83c0,.78,0,1.82,0,3.13,0,2.71-.1,6.5-.17,11.05l-.1-.19,8.6,5.15H249l7.59-5,1.51-1-.12.2c.19-5.37.38-10.42.54-14.8l.23.24-12.83.07h-4.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.84,316.51a14.68,14.68,0,0,1-2.84-.09c-1.75-.13-4.17-.37-6.82-.71s-5.05-.73-6.77-1a14.09,14.09,0,0,1-2.77-.64,15.68,15.68,0,0,1,2.82.27l6.79.9,6.78.86A17.07,17.07,0,0,1,288.84,316.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.35,375.32s-.08.31-.49.67a3.35,3.35,0,0,1-2.15.73,5.07,5.07,0,0,1-3.13-1.2,21.75,21.75,0,0,1-2.86-2.89,39.6,39.6,0,0,1-4.24-6,12.83,12.83,0,0,1-1.33-2.73,29.74,29.74,0,0,1,1.64,2.54,53,53,0,0,0,4.33,5.83,23.55,23.55,0,0,0,2.76,2.85,4.85,4.85,0,0,0,2.84,1.21,3.34,3.34,0,0,0,2-.52C288.15,375.54,288.31,375.3,288.35,375.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.94,377.18a1.44,1.44,0,0,1-.28.67,4.5,4.5,0,0,1-1.45,1.38,5.55,5.55,0,0,1-2.88.75,6.74,6.74,0,0,1-3.46-1.1,12.19,12.19,0,0,1-4.17-5,10.85,10.85,0,0,1-1-2.47,17.74,17.74,0,0,1,1.36,2.3,13.18,13.18,0,0,0,4.12,4.7,6.5,6.5,0,0,0,3.2,1.06,5.49,5.49,0,0,0,2.69-.59A6.12,6.12,0,0,0,246.94,377.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.28,369.22a5.17,5.17,0,0,1-1.73,1,13.7,13.7,0,0,1-9.47.39,5.36,5.36,0,0,1-1.8-.86,21.35,21.35,0,0,0,6.55,1A22,22,0,0,0,248.28,369.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.52,183H286s-4.16-2.39-6.17-2a7.92,7.92,0,0,0-3.75,2.55l4.05,33.68,9.9-7.33,36.86-3.83a11.74,11.74,0,0,0,8.42-3.69h0a11.74,11.74,0,0,0,3.11-9.43l-6.82-36.23-14,.47-.55,9.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.36,191.49a18.77,18.77,0,0,0-7.38,8.58c-1.79,4.28-14,25.66-20.38,36.84a10.58,10.58,0,0,0,1.53,12.57h0c3.9,4.07,8.56,2.48,14.25.63,2.55-.83,14-18.44,14-18.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.68 267.88 230.67 207.57 232.36 191.49 250.2 183.89 273.32 182.37 295.32 184.8 290.18 246.66 295.81 281.55 234.17 284.33 237.68 267.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.65,267.62c-.15,0-1.82-13.41-3.75-30s-3.37-30-3.23-30.06,1.82,13.42,3.75,30S237.79,267.6,237.65,267.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.87,198.33a2.3,2.3,0,0,1,0,.55c0,.41-.09.92-.14,1.54-.15,1.42-.34,3.35-.58,5.69-.49,4.87-1.15,11.47-1.88,18.77s-1.27,14-1.63,18.78c-.17,2.35-.31,4.28-.41,5.7-.05.63-.09,1.14-.12,1.55a3.25,3.25,0,0,1-.08.54,1.91,1.91,0,0,1,0-.54c0-.42,0-.93,0-1.56,0-1.35.12-3.3.24-5.71.27-4.82.78-11.48,1.48-18.81s1.45-14,2-18.76c.3-2.4.55-4.33.75-5.67.09-.62.17-1.13.23-1.54A2,2,0,0,1,294.87,198.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.27,258.38a11.47,11.47,0,0,1-1,1.19,14.35,14.35,0,0,1-1.25,1.31c-.52.48-1.08,1.06-1.78,1.6a26,26,0,0,1-2.32,1.76,32.14,32.14,0,0,1-2.83,1.78,35.26,35.26,0,0,1-14.58,4.35c-1.18.05-2.3.13-3.34.07a28.12,28.12,0,0,1-2.91-.2c-.88-.07-1.67-.25-2.37-.37a14.08,14.08,0,0,1-1.76-.41,8.65,8.65,0,0,1-1.47-.46c0-.12,2.13.54,5.64.87a25.77,25.77,0,0,0,2.87.13c1,.05,2.14-.05,3.3-.11a36.61,36.61,0,0,0,14.39-4.29c1-.59,2-1.11,2.82-1.71s1.63-1.15,2.32-1.69C282.78,260,284.18,258.3,284.27,258.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.68,269.64c-3-.86-3.17-3.69-2-4.9s3-1.37,4.71-1.13a23.48,23.48,0,0,0,5,.67c2.74-.18,5-2.09,6.94-4.07s3.71-4.2,6.21-5.34,6-.73,7.3,1.68a5.22,5.22,0,0,1-.3,5,11.52,11.52,0,0,1-3.71,3.64,30.34,30.34,0,0,1-24.12,4.45"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.13,184.23a8,8,0,0,1,4,3.19,8.15,8.15,0,0,1,1.77,4.81,20.49,20.49,0,0,0-2.19-4.5A20.8,20.8,0,0,0,288.13,184.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,183.55a3,3,0,0,0-.5-.3,2.61,2.61,0,0,0-1.66-.11,4.67,4.67,0,0,0-2.28,1.36,24.94,24.94,0,0,1-2.52,2.56,7.41,7.41,0,0,1-4.14,1.27c-1.57.08-3.24-.08-5-.13a99.19,99.19,0,0,0-11.42.25,73.19,73.19,0,0,0-20.2,4.46,61.56,61.56,0,0,0-5.75,2.55l-1.51.8c-.35.18-.54.26-.54.26s.17-.11.52-.3l1.49-.83a60.55,60.55,0,0,1,5.73-2.62,72,72,0,0,1,20.24-4.53A97.15,97.15,0,0,1,269.9,188c1.76.05,3.43.22,5,.15a7.31,7.31,0,0,0,4.07-1.22,28.46,28.46,0,0,0,2.52-2.52,4.57,4.57,0,0,1,2.34-1.35,2.53,2.53,0,0,1,1.69.14A1.57,1.57,0,0,1,286,183.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.92,195.91s-.21-.07-.62-.14a6.6,6.6,0,0,0-1.81-.06,10,10,0,0,0-2.76.74,32.42,32.42,0,0,0-3.39,1.74,19.29,19.29,0,0,1-4.25,1.83,27.4,27.4,0,0,1-5.26.85c-3.74.23-7.85.29-12.15.62-8.62.6-16.37,1.64-22,2.55-2.8.45-5,.87-6.6,1.16l-1.79.33-.63.11.62-.15,1.78-.37c1.55-.31,3.8-.76,6.59-1.22,5.58-1,13.34-2,22-2.61,4.31-.34,8.43-.39,12.16-.61a27.66,27.66,0,0,0,5.22-.83,18.82,18.82,0,0,0,4.23-1.79,31.27,31.27,0,0,1,3.42-1.72,10,10,0,0,1,2.8-.71,6,6,0,0,1,1.82.1A2.62,2.62,0,0,1,292.92,195.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.07,212.91s-.78.37-2.22.93a64.21,64.21,0,0,1-6.21,2.07,93.06,93.06,0,0,1-21.35,3.19,197.87,197.87,0,0,1-21.6-.51l-6.54-.51-1.77-.16c-.4,0-.62-.07-.62-.07l.62,0,1.78.12,6.54.44a207.66,207.66,0,0,0,21.58.45,95.57,95.57,0,0,0,21.32-3.12c2.66-.74,4.78-1.46,6.23-2,.72-.26,1.28-.5,1.66-.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.73,232.54s-.73.32-2.08.78a41.63,41.63,0,0,1-5.86,1.5,58.67,58.67,0,0,1-8.93.91c-3.38.12-7.1,0-11-.22-7.78-.52-14.82-1.07-19.92-.89-2.55.07-4.61.24-6,.4-.71.07-1.26.16-1.63.2l-.57.07a50.88,50.88,0,0,1,8.22-.81c5.12-.22,12.17.31,19.95.82,3.88.23,7.59.35,11,.24a61.61,61.61,0,0,0,8.91-.86,43.64,43.64,0,0,0,5.87-1.44c.68-.2,1.19-.41,1.55-.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.83,247.73s-2.83.93-7.5,2c-2.34.55-5.15,1.09-8.29,1.57s-6.6.85-10.26,1.09-7.15.23-10.32.16-6-.3-8.41-.56c-4.77-.5-7.69-1.09-7.69-1.09l.54.06,1.53.22c1.32.2,3.25.43,5.63.66s5.24.42,8.41.51,6.65,0,10.3-.17,7.11-.62,10.25-1.07,5.94-1,8.27-1.52,4.23-1,5.52-1.34l1.49-.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.94,253.28l-.52.2-1.5.54c-1.31.48-3.17,1.24-5.44,2.24s-5,2.26-8,3.51a52.18,52.18,0,0,1-10.22,3.13A85,85,0,0,1,245.88,264c-2.48-.1-4.49-.23-5.88-.32l-1.59-.12c-.37,0-.56,0-.56,0h.56l1.6.08,5.88.25a86.73,86.73,0,0,0,19.33-1.13,53,53,0,0,0,10.19-3.09c3-1.24,5.72-2.49,8-3.47s4.16-1.73,5.47-2.19S290.94,253.28,290.94,253.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.07,269.84s-.68.46-2,1.21a41,41,0,0,1-5.77,2.64,63.71,63.71,0,0,1-20.59,3.48c-8.19.15-15.59-.5-20.94-.73-2.68-.13-4.84-.2-6.34-.24l-1.73,0-.6,0s.21,0,.6,0h1.73c1.5,0,3.67.06,6.35.18,5.35.18,12.75.81,20.92.66a64.51,64.51,0,0,0,20.55-3.41A41.56,41.56,0,0,0,292,271c.67-.33,1.16-.66,1.51-.84S294.07,269.84,294.07,269.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.39,208.78a.94.94,0,0,1,.05-.25c.06-.22.12-.46.19-.71.17-.62.39-1.51.63-2.63a40.39,40.39,0,0,0-.27-17.64c-.26-1.11-.51-2-.7-2.61l-.22-.7L303,184a.72.72,0,0,1,.1.24c.08.21.16.44.25.69.22.6.49,1.48.77,2.59a38,38,0,0,1,.27,17.71c-.25,1.12-.49,2-.69,2.62-.09.25-.16.48-.23.7A1.78,1.78,0,0,1,303.39,208.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.2,205.16a.82.82,0,0,1,0-.23c0-.2,0-.42,0-.65,0-.57,0-1.39,0-2.4a37.3,37.3,0,0,0-3.49-15.31c-.43-.91-.81-1.65-1.08-2.14l-.31-.58q-.11-.19-.09-.21a1.8,1.8,0,0,1,.13.19l.34.56c.3.48.69,1.21,1.14,2.12a34.83,34.83,0,0,1,3.5,15.37,23.84,23.84,0,0,1-.1,2.4l-.07.66A1.42,1.42,0,0,1,318.2,205.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.21,198.21s-.07-.06-.19-.2l-.51-.59c-.43-.53-1.08-1.27-1.91-2.15a48.42,48.42,0,0,0-15.34-11c-1.11-.5-2-.88-2.66-1.12l-.73-.28a1.34,1.34,0,0,1-.25-.12,1,1,0,0,1,.27.08l.74.25c.65.21,1.57.57,2.69,1.06a45.58,45.58,0,0,1,15.39,11c.81.9,1.45,1.65,1.86,2.2.18.22.34.43.48.62S338.21,198.21,338.21,198.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.67,169.88a4,4,0,0,1-.64,0l-1.73,0c-1.46,0-3.48,0-5.72,0s-4.25.12-5.71.2l-1.73.09a4.49,4.49,0,0,1-.64,0,3.94,3.94,0,0,1,.64-.09c.4,0,1-.1,1.72-.16,1.46-.11,3.49-.22,5.72-.26s4.26,0,5.72.06l1.74.1A4,4,0,0,1,333.67,169.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.38,209.57a2.48,2.48,0,0,1,.38.39c.22.27.57.64,1,1.09a26,26,0,0,0,3.74,3.11,46.6,46.6,0,0,0,4.18,2.54l1.3.71a2.89,2.89,0,0,1,.47.28,2.25,2.25,0,0,1-.5-.21c-.32-.14-.78-.36-1.34-.65a38.87,38.87,0,0,1-4.23-2.49,23.59,23.59,0,0,1-3.73-3.19,12.78,12.78,0,0,1-1-1.14A3,3,0,0,1,220.38,209.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.6,201.56s.23.35.7.81a16,16,0,0,0,2,1.59,25.18,25.18,0,0,0,2.21,1.34c.58.32,1,.48.95.51a11.31,11.31,0,0,1-3.27-1.67,11.64,11.64,0,0,1-2-1.67A2.41,2.41,0,0,1,224.6,201.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.71,235.68s-.08,0-.22-.09l-.61-.32c-.52-.28-1.27-.71-2.16-1.29a45.23,45.23,0,0,1-6.52-5.17,41.5,41.5,0,0,1-5.43-6.29,23.5,23.5,0,0,1-1.34-2.14l-.33-.6c-.08-.14-.11-.21-.1-.22l.13.2.37.58c.3.51.77,1.23,1.39,2.09a45.5,45.5,0,0,0,5.46,6.23,48.36,48.36,0,0,0,6.45,5.19c.88.6,1.61,1.05,2.12,1.35l.59.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.93,246a4.94,4.94,0,0,1-.19-1.15,18.87,18.87,0,0,1-.07-3.16,20.46,20.46,0,0,1,3.32-9.83c2.15-3.44,4.12-6.54,5.57-8.77l1.74-2.62a5.76,5.76,0,0,1,.7-.93,5,5,0,0,1-.53,1l-1.6,2.71c-1.37,2.28-3.29,5.4-5.43,8.84a21.21,21.21,0,0,0-3.4,9.59C203.81,244.36,204,246,203.93,246Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.43,250.06a12.81,12.81,0,0,1-3.46-.52,16.23,16.23,0,0,1-11.45-11.45,13,13,0,0,1-.51-3.45.92.92,0,0,1,0,.24c0,.15,0,.39.09.69a17.08,17.08,0,0,0,.53,2.48A16.4,16.4,0,0,0,218,249.4a17.44,17.44,0,0,0,2.49.53c.3,0,.53.06.69.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.39,215.92a.74.74,0,0,1-.18.12l-.52.32a21.29,21.29,0,0,0-1.86,1.23A26.51,26.51,0,0,0,199.75,229c-.36.87-.63,1.58-.78,2.09-.07.2-.14.39-.2.58s-.07.19-.08.19a.87.87,0,0,1,0-.21c.05-.18.1-.38.16-.59a18.78,18.78,0,0,1,.73-2.12,25.9,25.9,0,0,1,3.71-6.39,25.54,25.54,0,0,1,5.41-5,17.86,17.86,0,0,1,1.91-1.18l.54-.28C211.32,215.94,211.38,215.91,211.39,215.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.78,208.52l-.57.2c-.37.11-.9.3-1.54.56a17.9,17.9,0,0,0-4.59,2.78,26,26,0,0,0-3.72,3.9c-.43.54-.77,1-1,1.3a4.16,4.16,0,0,1-.38.47,3.75,3.75,0,0,1,.31-.52c.21-.32.53-.79.94-1.34a22.85,22.85,0,0,1,3.71-4,16.44,16.44,0,0,1,4.67-2.76,14.57,14.57,0,0,1,1.57-.5A3.62,3.62,0,0,1,205.78,208.52Z",
    style: {
      fill: "#fafafa"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline2);
export default __webpack_public_path__ + "static/media/online2.f3e33f0f83a3c8d1501ea33572c30552.svg";
export { ForwardRef as ReactComponent };